"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("damages").controller("DamagesCtrl", DamagesCtrl);

  function DamagesCtrl($rootScope, $scope, $timeout, $controller, moment, AgGridService, ModalService, CustomListsService, CustomersService, UsersService, VehiclesService, DamagesService, DepasService, GroupsService, LalsService, InsurerContractsService, EmailHistoryService, READ_SUMMARY_URL, APP_URL) {
    var _this = this;

    var vm = this;

    vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isLvr = ["super-admin", "super-operator", "operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.ctrlName = "DamagesCtrl";

    vm.activeTab = "tous";

    vm.log = debug("pages:damages");

    vm.tutoIsActived = true;

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,
      service: DamagesService,
      params: {
        editPage: "damages/damage"
      }
    });

    vm.gridEvent = function (value) {
      vm.log(value);

      if (value.type == "rowDoubleClicked") {
        if (!value.data.source) {
          // = not lal
          vm.edit(value.data);
        }
      } else if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 4;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Sinistres"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.setGridColumns = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var displayWriteBt, displayDeleteBt, columnsInsurer, refColumns, adminColumns, adminGroup;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CustomersService.findById({
                  _id: $rootScope.$selectedCustomerId.replace("$", ""),
                  filter: {
                    fields: {
                      needToInformManagerAfterDamageCreation: true,
                      defaultInsurerContract: true,
                      eadPartner: true,
                      eadPartnerEmail: true,
                      sendToInsurerOnlyIfThirdParty: true,
                      autoInsurerSendTypes: true
                    }
                  }
                });

              case 2:
                vm.customer = _context.sent;
                displayWriteBt = vm.isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.write && $rootScope.$user.rights.damage.write === true;
                displayDeleteBt = vm.isAdmin || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.delete && $rootScope.$user.rights.damage.delete === true;


                vm.displaySendBt = vm.isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.send && $rootScope.$user.rights.damage.send === true;

                if (displayWriteBt !== true) {
                  vm.create = null;
                  vm.openDocumentRequests = null;
                  vm.edit = null;
                }

                columnsInsurer = [AgGridService.text("refInsurer", "Réf. provisoire assureur", 150), AgGridService.text("insurerRefInsurer", "Réf. saisie par l'assureur/courtier", 150), AgGridService.text("refLal", "Réf. assureur", 150), AgGridService.text("insurerDocs", "Docs transmis à l'assureur/courtier", 160, {
                  columnGroupShow: "open"
                }), AgGridService.date("dateInsurerReport", "Date de la transmission assureur/courtier", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("insurerContractName", "Contrat", 170, {
                  columnGroupShow: "open"
                }), AgGridService.text("insurerContract.insurerEdiEmail", "EDI Email", 170, {
                  columnGroupShow: "open"
                }), AgGridService.bool("refCheckInsurer", "Rapproché", 120, {
                  columnGroupShow: "open"
                })];


                if (vm.customer.eadPartner === "autogriff" || vm.customer.eadPartner === "custom" && vm.customer.eadPartnerEmail) {
                  columnsInsurer.unshift(AgGridService.date("eadResponseDate", "Date de transmission Chiffrage", 160, {
                    columnGroupShow: "open"
                  }), AgGridService.text("eadResponseStatus", "Statut de la transmission Chiffrage", 160, {
                    columnGroupShow: "open"
                  }));
                }

                refColumns = [AgGridService.text("groupName", "Groupe associé", 120), AgGridService.text("managerName", "Responsable du suivi", 120), AgGridService.text("typeDamageStatusName", "Statut du dossier"), AgGridService.text("customClassification", "Classification interne", 100, {
                  columnGroupShow: "open"
                }), AgGridService.date("dateOpenDispute", "Date Ouverture", 150, {
                  columnGroupShow: "open"
                }), AgGridService.date("dateCloseDispute", "Date Clôture", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("refLal", "Réf. assureur", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("statusLal", "Statut assureur", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("lalPourcentageDispute", "Resp. assureur", 80, {
                  columnGroupShow: "open"
                }), AgGridService.text("pourcentageDispute", "Resp. présumée", 80, {
                  columnGroupShow: "open"
                }), AgGridService.date("dateLastAction", "Date dernière action", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("lastAction", "Action menée", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("contactLastAction", "Action vers", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("nextAction", "Prochaine action", 150, {
                  columnGroupShow: "open"
                }), AgGridService.date("creationDate", "Créé le", 130, {
                  columnGroupShow: "open"
                }), AgGridService.text("creationUserName", "Créé par", 130, {
                  columnGroupShow: "open"
                }), AgGridService.date("lastUserModificationDate", "Dernière modif. le", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("lastUserName", "Dernière modif. par", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("appName", "Appli utilisé pour la déclaration", 150, {
                  columnGroupShow: "open"
                }), AgGridService.bool("formReceived", "Constat reçu ?", 100, {
                  columnGroupShow: "open"
                })];
                adminColumns = [];

                if (displayWriteBt || displayDeleteBt || vm.displaySendBt === true) {
                  if (displayWriteBt) {
                    adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, _this, {
                      width: 90
                    }));
                    adminColumns.push(AgGridService.button("btManager", "Informer", vm.informManagerModal, _this, {
                      width: 120
                    }));
                  }
                  if (vm.displaySendBt === true) {
                    adminColumns.push(AgGridService.button("btInsurer", "Transmettre à l'assurance", vm.informInsurer, _this, {
                      width: 160
                    }));
                  }
                  if ((vm.isLvr === true || vm.isAdmin === true) && (vm.customer.eadPartner === "autogriff" || vm.customer.eadPartner === "custom" && vm.customer.eadPartnerEmail)) {
                    adminColumns.push(AgGridService.button("btEadPage", "Ouvrir la page du chiffrage", vm.openEadPage, _this, {
                      width: 200
                    }));
                    if (vm.customer.eadPartner !== "autogriff") {
                      adminColumns.push(AgGridService.button("btEadResend", "Renvoyer la demande au chiffreur", vm.resendEad, _this, {
                        width: 200,
                        columnGroupShow: "open"
                      }));
                    }
                    adminColumns.push(AgGridService.button("btEadLink", "Envoyer le lien de chiffrage au collaborateur", vm.sendEadLink, _this, {
                      width: 200,
                      columnGroupShow: "open"
                    }));
                  }
                  if (displayDeleteBt && displayWriteBt) {
                    adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this, {
                      width: 90,
                      columnGroupShow: "open"
                    }));
                  } else if (displayDeleteBt) {
                    adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, _this, {
                      width: 90
                    }));
                  }
                }

                vm.columnDefs0 = [AgGridService.text("name", "Réf.", 120, { pinned: "left" }), AgGridService.text("driverName", "Collaborateur sinistré", 150, {
                  pinned: "left"
                }), AgGridService.text("vehicleName", "Véhicule", 100, { pinned: "left" }), AgGridService.group("Suivi du dossier", refColumns), AgGridService.group("Circonstances", [AgGridService.text("typeOfAccidentName", "Type de sinistre", 100), AgGridService.date("dateDamage", "Survenance", 130), AgGridService.text("year", "Année", 130, {
                  columnGroupShow: "open"
                }), AgGridService.text("month", "Mois", 130, {
                  columnGroupShow: "open"
                }), AgGridService.text("day", "Jour", 130, {
                  columnGroupShow: "open"
                }), AgGridService.text("location", "Lieu", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("tourNumber", "N° de la tournée ou N° de l'OT", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("tourCustomer", "Nom du client lié à la tournée ou à l'OT", 150, {
                  columnGroupShow: "open"
                }), AgGridService.bool("drivingLicenceValid", "Permis déclaré valide ?", 75, {
                  columnGroupShow: "open"
                }), AgGridService.bool("withInjury", "Blessé(s) même léger(s)", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("typeOfInjuryName", "Qui a été blessé ?", 100, {
                  columnGroupShow: "open"
                }), AgGridService.bool("withThirdParty", "Avec tiers ?", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("thirdPartyDriverName", "Nom tiers", 100), AgGridService.text("thirdPartyCompagnyName", "Société tiers", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("thirdPartyAssurerName", "Assureur tiers", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("circumstance", "Circonstances", 75, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Véhicule", [AgGridService.text("vehicleType", "Type de véhicule", 100), AgGridService.bool("vehicleToCheck", "À vérifier", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("vehicleCompany", "Société véhicule", 100, {
                  columnGroupShow: "open"
                }), AgGridService.bool("severityDamageName", "Gravité des dommages sur le véhicule", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("trailerName", "N° Remorque", 100, {
                  columnGroupShow: "open"
                }), AgGridService.bool("trailerDamaged", "Rem. abimé", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("containerName", "N° Conteneur", 100, {
                  columnGroupShow: "open"
                }), AgGridService.bool("containerDamaged", "Cont. abimé", 100, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Estimation des réparations", [AgGridService.currency("estimateAmountHT", "Montant estimé des réparations (HT)", 150), AgGridService.currency("estimateAmountNotRepairedHT", "Montant estimé des dommages non réparés (HT)", 150)]), AgGridService.group("Expertise", [AgGridService.date("dateReport", "Date de l'expertise", 150), AgGridService.text("damageExpertName", "Nom/Société de l'expert", 150, {
                  columnGroupShow: "open"
                }), AgGridService.currency("damageExpertCostHT", "Montant de l'expertise (HT)", 150, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Réparateur", [AgGridService.text("repairerInfo", "Nom du réparateur", 150), AgGridService.text("repairerAddress", "Adresse du réparateur", 150, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Assurance", columnsInsurer), AgGridService.group("Collaborateur sinistré", [AgGridService.bool("driverIsRelative", "Conjoint/Enfant/Proche", 150, {
                  columnGroupShow: "open"
                }), AgGridService.bool("driverToCheck", "À vérifier", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("driverInternalName", "Matricule", 150, {
                  columnGroupShow: "open"
                }), AgGridService.text("driverContract", "Contrat", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("malusDriverAmount", "Malus prime collaborateur", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("driverExternalCompany", "Société d'intérim", 100, {
                  columnGroupShow: "open"
                }), AgGridService.text("driverSeniority", "Ancienneté (en mois) au moment du sinistre", 150, {
                  columnGroupShow: "open"
                }), AgGridService.number("nbDamages", "Nb Sinistres", 100, {
                  columnGroupShow: "open"
                }), AgGridService.number("driverNbDispute100", "Resp 100%", 100, {
                  columnGroupShow: "open"
                }), AgGridService.number("driverNbDispute50", "Resp 50%", 100, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Coût total", [AgGridService.currency("newCostTotal", "Total", 100)]), AgGridService.group("Côut à notre charge", [AgGridService.currency("newCostCompagny", "Total", 100), AgGridService.currency("costDeductible", "Franchise / Auto Assurance", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("costInternal", "Réparation véhicule interne / Provision FRE", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("costThirdParty", "Indemnisation tiers", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("refundThirdParty", "Remboursement par le tiers", 100, {
                  columnGroupShow: "open"
                })]), AgGridService.group("Coût Assureur", [AgGridService.currency("newCostInsurer", "Total", 100), AgGridService.currency("costTotalLal", "Coût transmis par l'assureur à LVR", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("costProvision", "Estimation par le client", 100, {
                  columnGroupShow: "open"
                })]), AgGridService.bool("aggreement", "Accord amiable ?", 100), AgGridService.text("costNotes", "Notes", 100, {
                  columnGroupShow: "open"
                }), AgGridService.currency("costRelatedToDriver", "Montant retenu pour calcul prime", 100, {
                  columnGroupShow: "open"
                })];

                vm.columnDefs3 = [AgGridService.text("refDamage", "Réf. DRM", 120, {
                  pinned: "left"
                }), AgGridService.text("refInsurer", "Réf. assureur", 130, {
                  pinned: "left"
                }), AgGridService.date("dateDamage", "Survenance", 130), AgGridService.text("driverName", "NOM prénom", 150), AgGridService.text("groupName", "Groupe", 150), AgGridService.text("plateNumber", "Véhicule", 100), AgGridService.text("what", "Circonstance", 100), AgGridService.text("pourcentageDispute", "Resp. assureur", 100), AgGridService.text("statusInsurer", "Statut", 100), AgGridService.currency("costTotal", "Coût", 100), AgGridService.currency("costDeductible", "Franchise", 100), AgGridService.group("Import", [AgGridService.date("dateImport", "Date", 130), AgGridService.text("source", "Fichier", 100, {
                  columnGroupShow: "open"
                })])];

                vm.columnDefs0.unshift(AgGridService.button("btSee", "Fiche récap.", vm.displayInfo, _this, {
                  width: 110
                }));
                if (adminColumns && adminColumns.length > 0) {
                  adminGroup = AgGridService.group("Admin", adminColumns);

                  vm.columnDefs0.unshift(adminGroup);
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    vm.openDocumentRequests = function () {
      ModalService.openComponent("document-requests", { size: "lg" }).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return vm.refresh();

              case 2:
                console.log("close modal");

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }))).catch(function (err) {
        console.log("err", err);
      });
    };

    vm.resendEad = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var confirmEad;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return swal({
                  text: "Voulez-vous transmettre de nouveau ce sinistre pour le chiffrage des r\xE9parations ?",
                  icon: "info",
                  dangerMode: false,
                  buttons: ["Non", "Oui"]
                });

              case 2:
                confirmEad = _context3.sent;

                if (!confirmEad) {
                  _context3.next = 17;
                  break;
                }

                Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");

                _context3.prev = 5;
                _context3.next = 8;
                return DamagesService.customPost("performEad/" + row._id);

              case 8:
                Notiflix.Notify.success("Envoi réussi");
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](5);

                Notiflix.Notify.failure("Echec de l'envoi");

              case 14:

                Notiflix.Loading.remove();

                _context3.next = 17;
                return vm.refresh();

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[5, 11]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    vm.openEadPage = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var source;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                source = APP_URL + "/?eadId=" + row.shortId;


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  size: "lg",
                  heightCalculationMethod: "bodyOffset",
                  minHeight: 850,
                  closeEvent: "init",
                  color: "#004369"
                }).then(function () {
                  console.log("close modal");
                }).catch(function (err) {
                  console.error("err", err);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }();

    vm.createDepaAfterDamage = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(newDamage) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return Notiflix.Confirm.show("Attention", "Voulez-vous créer le DEPA ?", "Oui", "Non", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  var response;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          Notiflix.Loading.standard("Sauvegarde en cours...");
                          _context5.prev = 1;
                          _context5.next = 4;
                          return DepasService.customPost("createOne/" + newDamage._id);

                        case 4:
                          response = _context5.sent;

                          if (!(response && response.success === true)) {
                            _context5.next = 11;
                            break;
                          }

                          Notiflix.Notify.success("DEPA créé avec succès");
                          _context5.next = 9;
                          return vm.refresh();

                        case 9:
                          _context5.next = 12;
                          break;

                        case 11:
                          Notiflix.Notify.failure("Erreur lors de la création du DEPA");

                        case 12:
                          _context5.next = 17;
                          break;

                        case 14:
                          _context5.prev = 14;
                          _context5.t0 = _context5["catch"](1);

                          Notiflix.Notify.failure("Erreur lors de la création du DEPA");

                        case 17:
                          Notiflix.Loading.remove();

                        case 18:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this, [[1, 14]]);
                })), function () {});

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }();

    vm.sendEadLink = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(row) {
        var label1, textInput1, label2, textInput2, div, sendEadLink;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                label1 = document.createElement("label");

                label1.innerHTML = "Email : ";
                label1.setAttribute("for", "textInput1");
                label1.classList.add("control-label");

                textInput1 = document.createElement("input");

                textInput1.type = "text";
                textInput1.classList.add("form-control");

                label2 = document.createElement("label");

                label2.innerHTML = "Tel. portable : ";
                label2.setAttribute("for", "textInput2");
                label2.classList.add("control-label");

                textInput2 = document.createElement("input");

                textInput2.type = "text";
                textInput2.classList.add("form-control");

                div = document.createElement("div");

                div.appendChild(label1);
                div.appendChild(textInput1);
                div.appendChild(document.createElement("br"));
                div.appendChild(label2);
                div.appendChild(textInput2);

                _context7.next = 22;
                return swal({
                  title: "Envoyer le lien pour la prise de photos à :",
                  content: {
                    element: div
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Annuler", "Valider"]
                });

              case 22:
                sendEadLink = _context7.sent;

                if (!(sendEadLink && (textInput1.value || textInput2.value))) {
                  _context7.next = 37;
                  break;
                }

                Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");

                _context7.prev = 25;
                _context7.next = 28;
                return DamagesService.customPost("sendEadLink/" + row._id, {
                  email: textInput1.value ? textInput1.value : "",
                  cellularPhone: textInput2.value ? textInput2.value : ""
                });

              case 28:
                Notiflix.Notify.success("Envoi réussi");
                _context7.next = 34;
                break;

              case 31:
                _context7.prev = 31;
                _context7.t0 = _context7["catch"](25);

                Notiflix.Notify.failure("Echec de l'envoi");

              case 34:

                Notiflix.Loading.remove();
                _context7.next = 38;
                break;

              case 37:
                if (sendEadLink) {
                  Notiflix.Notify.failure("Aucun email ou numéro de téléphone renseigné");
                }

              case 38:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this, [[25, 31]]);
      }));

      return function (_x5) {
        return _ref7.apply(this, arguments);
      };
    }();

    vm.refresh = function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(params) {
        var typeOfAccidentList, severityDamageList, typeOfInjuryList, docsSent, docsNotSent, docsSentList, response, _response, _damage, newDamage, newDepa, driver, insurerDefaultContract, extendTo, where, promises, datas, damages, lals, damageNameById, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _damage2, lalsByRef, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _lal, names, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _id, name, index, damage, reporterName, user, _docsSentList, group, dateDommage, lal, _driver, type, typeOfInjuryData, typeOfAccidentData, typeOfAccident, severityDamageData, onlyUnique, text, vehicle, source;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if ($rootScope.$selectedCustomerId) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _context8.prev = 3;
                _context8.next = 6;
                return vm.setGridColumns();

              case 6:

                vm.log("refresh damages", params);

                if (params && params.from && params.to) {
                  vm.from = params.from;
                  vm.to = params.to;
                }

                if (!vm.from || !vm.to) {
                  vm.from = moment().subtract(12, "months").startOf("month").toDate();
                  vm.to = moment().endOf("month").toDate();
                }

                UsersService.clearCache();
                VehiclesService.clearCache();
                InsurerContractsService.clearCache();

                _context8.next = 14;
                return CustomListsService.getSelectArray("typeOfAccidentV2");

              case 14:
                typeOfAccidentList = _context8.sent;
                _context8.next = 17;
                return CustomListsService.getSelectArray("severityDamage");

              case 17:
                severityDamageList = _context8.sent;
                _context8.next = 20;
                return CustomListsService.getSelectArray("typeOfInjury");

              case 20:
                typeOfInjuryList = _context8.sent;
                docsSent = 0;
                docsNotSent = 0;

                if (params && params.edit && params.edit.docs) {
                  docsSentList = params.edit.docs.filter(function (doc) {
                    return doc.insurerTransmissionDate;
                  });

                  docsSent = docsSentList.length;
                  docsNotSent = params.edit.docs.length - docsSent;
                }

                if (!(
                // Send to Insurer if edit and type in list and no EAD
                params && params.edit && vm.customer.autoInsurerSendTypes && vm.customer.autoInsurerSendTypes.length > 0 && vm.customer.autoInsurerSendTypes.includes(params.edit.typeOfAccident) && vm.customer.eadPartner !== "autogriff" && (
                // Pas d'envoi à l'assureur si pas de tiers impliqué et sendToInsurerOnlyIfThirdParty à true
                vm.customer.sendToInsurerOnlyIfThirdParty !== true || damage.withThirdParty === true) && (!params.edit.insurer || !params.edit.insurer.dateReport))) {
                  _context8.next = 39;
                  break;
                }

                _context8.next = 27;
                return DamagesService.updateAttributesById(params.edit._id, {
                  insurer: { noReport: false }
                });

              case 27:
                _context8.prev = 27;
                _context8.next = 30;
                return DamagesService.customPost("sendToInsurer", {
                  damageId: params.edit._id,
                  templateName: "damage.edi"
                });

              case 30:
                response = _context8.sent;

                if (response && response.success === true) {
                  Notiflix.Notify.success("Envoi réussi");
                } else {
                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + response.info);
                }
                _context8.next = 37;
                break;

              case 34:
                _context8.prev = 34;
                _context8.t0 = _context8["catch"](27);

                Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context8.t0.message);

              case 37:
                _context8.next = 55;
                break;

              case 39:
                if (!(
                // Block report if not in list and no EAD
                params && params.edit && vm.customer.autoInsurerSendTypes && vm.customer.autoInsurerSendTypes.length > 0 && !vm.customer.autoInsurerSendTypes.includes(params.edit.typeOfAccident) && vm.customer.eadPartner !== "autogriff" && (
                // Pas d'envoi à l'assureur si pas de tiers impliqué et sendToInsurerOnlyIfThirdParty à true
                vm.customer.sendToInsurerOnlyIfThirdParty !== true || damage.withThirdParty === true) && (!params.edit.insurer || !params.edit.insurer.dateReport))) {
                  _context8.next = 44;
                  break;
                }

                _context8.next = 42;
                return DamagesService.updateAttributesById(params.edit._id, {
                  insurer: { noReport: true }
                });

              case 42:
                _context8.next = 55;
                break;

              case 44:
                if (!(
                // Send new docs to Insurer if edit and type in list and no EAD
                params && params.edit && vm.customer.autoInsurerSendTypes && vm.customer.autoInsurerSendTypes.length > 0 && vm.customer.autoInsurerSendTypes.includes(params.edit.typeOfAccident) && vm.customer.eadPartner !== "autogriff" && (
                // Pas d'envoi à l'assureur si pas de tiers impliqué et sendToInsurerOnlyIfThirdParty à true
                vm.customer.sendToInsurerOnlyIfThirdParty !== true || damage.withThirdParty === true) && params.edit.insurer && params.edit.insurer.dateReport && docsNotSent > 0)) {
                  _context8.next = 55;
                  break;
                }

                _context8.prev = 45;
                _context8.next = 48;
                return DamagesService.customPost("sendToInsurer", {
                  damageId: params.edit._id,
                  templateName: "damage.docsInsurerEdi"
                });

              case 48:
                _response = _context8.sent;

                if (_response && _response.success === true) {
                  Notiflix.Notify.success("Envoi réussi");
                } else {
                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _response.info);
                }
                _context8.next = 55;
                break;

              case 52:
                _context8.prev = 52;
                _context8.t1 = _context8["catch"](45);

                Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context8.t1.message);

              case 55:
                if (!(params && (params.create || params.edit && !params.edit.depaId))) {
                  _context8.next = 104;
                  break;
                }

                _damage = void 0;

                if (params.create) {
                  _damage = params.create;
                } else if (params.edit) {
                  _damage = params.edit;
                }

                _context8.next = 60;
                return DamagesService.findById({ _id: _damage._id });

              case 60:
                newDamage = _context8.sent;

                if (!(params.create && vm.customer.needToInformManagerAfterDamageCreation === true)) {
                  _context8.next = 66;
                  break;
                }

                Notiflix.Loading.remove();
                _context8.next = 65;
                return vm.informManagerModal(newDamage, true);

              case 65:
                // true -> disable vm.refresh (avoid refresh within refresh and duplicate lines)
                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

              case 66:
                if (newDamage.depaId) {
                  _context8.next = 69;
                  break;
                }

                _context8.next = 69;
                return vm.createDepaAfterDamage(newDamage);

              case 69:
                if (!(params.create && newDamage.driverId && newDamage.driverId.length >= 24)) {
                  _context8.next = 104;
                  break;
                }

                _context8.next = 72;
                return DepasService.getById(newDamage.depaId.replace("$", ""));

              case 72:
                newDepa = _context8.sent;

                if (!(!newDepa || newDepa.error)) {
                  _context8.next = 79;
                  break;
                }

                _context8.next = 76;
                return DepasService.clearCache();

              case 76:
                _context8.next = 78;
                return DepasService.getById(newDamage.depaId.replace("$", ""));

              case 78:
                newDepa = _context8.sent;

              case 79:
                _context8.next = 81;
                return UsersService.getById(newDamage.driverId);

              case 81:
                driver = _context8.sent;

                if (!(newDepa.status !== "Annulé")) {
                  _context8.next = 104;
                  break;
                }

                newDamage.depa = newDepa;
                newDamage.driver = driver;

                if (!(newDepa.emailToUse && newDepa.emailToUse.includes($rootScope.$user.email))) {
                  _context8.next = 90;
                  break;
                }

                _context8.next = 88;
                return vm.scheduleDepa(newDamage, false, true, true);

              case 88:
                _context8.next = 104;
                break;

              case 90:
                if (!(newDepa.emailToUse && newDepa.phoneToUse)) {
                  _context8.next = 94;
                  break;
                }

                Notiflix.Report.success("Prise de RDV", "Le mail de prise de RDV a \xE9t\xE9 envoy\xE9 \xE0 " + newDepa.emailToUse + " et le SMS au " + newDepa.phoneToUse + ".", "Ok");
                _context8.next = 104;
                break;

              case 94:
                if (!newDepa.emailToUse) {
                  _context8.next = 98;
                  break;
                }

                Notiflix.Report.success("Prise de RDV", "Le mail de prise de RDV a \xE9t\xE9 envoy\xE9 \xE0 " + newDepa.emailToUse + ".", "Ok");
                _context8.next = 104;
                break;

              case 98:
                if (!newDepa.phoneToUse) {
                  _context8.next = 102;
                  break;
                }

                Notiflix.Report.success("Prise de RDV", "Le SMS de prise de RDV a \xE9t\xE9 envoy\xE9 au " + newDepa.phoneToUse + ".", "Ok");
                _context8.next = 104;
                break;

              case 102:
                _context8.next = 104;
                return vm.scheduleDepa(newDamage, false, false, true);

              case 104:
                insurerDefaultContract = void 0;

                if (!vm.customer.defaultInsurerContract) {
                  _context8.next = 110;
                  break;
                }

                _context8.next = 108;
                return InsurerContractsService.getById(vm.customer.defaultInsurerContract);

              case 108:
                insurerDefaultContract = _context8.sent;


                console.log("Default Contract", vm.customer.defaultInsurerContract, insurerDefaultContract);

              case 110:
                extendTo = moment(vm.to).add(1, "m");
                where = { dateDamage: { $gte: vm.from, $lte: extendTo.toDate() } };
                _context8.next = 114;
                return DamagesService.load(["name", "_id", "depaId", "driverId", "vehicleId", "customerId", "groupId", "managerId", "typeOfAccident", "dateDamage", "creationDate", "lastUserModificationDate", "location", "typeDamageStatus", "customClassification", "dateOpenDispute", "dateCloseDispute", "insurer", "refInsurer", "pourcentageDispute", "costTotal", "costNotes", "costCompagny", "costDeductible", "costThirdParty", "costInternal", "costInsurer", "costProvision", "refundThirdParty", "aggreement", "dateLastAction", "lastAction", "contactLastAction", "nextAction", "appName", "docs", "docsBilling", "driverIsRelative", "tourNumber", "tourCustomer", "drivingLicenceValid", "withInjury", "typeOfInjury", "withThirdParty", "thirdPartyDriverName", "thirdPartyCompagnyName", "thirdPartyAssurerName", "circumstance", "severityDamage", "mileage", "trailerName", "trailerDamaged", "containerName", "containerDamaged", "expertName", "damageExpertCostHT", "costRelatedToDriver", "estimateAmountHT", "estimateAmountNotRepairedHT", "repairerInfo", "repairerAddress", "malusDriverAmount", "shortId", "informManager", "eadResponseStatus", "eadResponseDate", "creationUserId", "lastUserId", "decosiInfo", "externalVehicleName"], false, null, where);

              case 114:
                _context8.t2 = _context8.sent;
                _context8.next = 117;
                return LalsService.load(["_id", "refInsurer", "damageIds", "costTotal", "costDeductible", "statusInsurer", "pourcentageDispute", "dateDamage", "driverName", "groupId", "plateNumber", "what", "dateImport", "source"], false, null, {
                  dateDamage: { $gte: vm.from, $lte: extendTo.toDate() }
                });

              case 117:
                _context8.t3 = _context8.sent;
                _context8.next = 120;
                return CustomListsService.getSelectArray("managerActMethod");

              case 120:
                _context8.t4 = _context8.sent;
                promises = [_context8.t2, _context8.t3, _context8.t4];
                _context8.next = 124;
                return Promise.all(promises);

              case 124:
                datas = _context8.sent;
                damages = datas[0];
                lals = datas[1];

                vm.managerActMethodList = datas[2];

                damageNameById = new Map();

                if (!(damages && damages.length)) {
                  _context8.next = 149;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context8.prev = 133;

                for (_iterator = damages[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _damage2 = _step.value;

                  damageNameById.set(_damage2._id, _damage2.name);
                }
                _context8.next = 141;
                break;

              case 137:
                _context8.prev = 137;
                _context8.t5 = _context8["catch"](133);
                _didIteratorError = true;
                _iteratorError = _context8.t5;

              case 141:
                _context8.prev = 141;
                _context8.prev = 142;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 144:
                _context8.prev = 144;

                if (!_didIteratorError) {
                  _context8.next = 147;
                  break;
                }

                throw _iteratorError;

              case 147:
                return _context8.finish(144);

              case 148:
                return _context8.finish(141);

              case 149:
                lalsByRef = new Map();

                vm.lalsData = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context8.prev = 154;
                _iterator2 = lals[Symbol.iterator]();

              case 156:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context8.next = 186;
                  break;
                }

                _lal = _step2.value;

                if (_lal.costTotal) {
                  _lal.costTotal = Math.round(_lal.costTotal * 100) / 100;
                }

                if (!(_lal.damageIds && _lal.damageIds.length)) {
                  _context8.next = 182;
                  break;
                }

                names = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context8.prev = 164;

                for (_iterator3 = _lal.damageIds[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  _id = _step3.value;

                  lalsByRef.set(_id, _lal);

                  name = damageNameById.get(_id);

                  if (name) {
                    names.push(name);
                  }
                }

                _context8.next = 172;
                break;

              case 168:
                _context8.prev = 168;
                _context8.t6 = _context8["catch"](164);
                _didIteratorError3 = true;
                _iteratorError3 = _context8.t6;

              case 172:
                _context8.prev = 172;
                _context8.prev = 173;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 175:
                _context8.prev = 175;

                if (!_didIteratorError3) {
                  _context8.next = 178;
                  break;
                }

                throw _iteratorError3;

              case 178:
                return _context8.finish(175);

              case 179:
                return _context8.finish(172);

              case 180:
                _lal.refDamage = names.join(", ");
                _lal.pourcentageDispute = typeof _lal.pourcentageDispute !== "undefined" && _lal.pourcentageDispute !== null && ["0", "50", "100"].includes(_lal.pourcentageDispute.toString()) ? _lal.pourcentageDispute.toString() + " %" : "";

              case 182:
                vm.lalsData.push(_lal);

              case 183:
                _iteratorNormalCompletion2 = true;
                _context8.next = 156;
                break;

              case 186:
                _context8.next = 192;
                break;

              case 188:
                _context8.prev = 188;
                _context8.t7 = _context8["catch"](154);
                _didIteratorError2 = true;
                _iteratorError2 = _context8.t7;

              case 192:
                _context8.prev = 192;
                _context8.prev = 193;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 195:
                _context8.prev = 195;

                if (!_didIteratorError2) {
                  _context8.next = 198;
                  break;
                }

                throw _iteratorError2;

              case 198:
                return _context8.finish(195);

              case 199:
                return _context8.finish(192);

              case 200:

                vm.rawData = [];
                vm.rawDataOpened = [];
                vm.rawDataClosed = [];

                if (!(damages && damages.length > 0)) {
                  _context8.next = 344;
                  break;
                }

                index = 0;

              case 205:
                if (!(index < damages.length)) {
                  _context8.next = 344;
                  break;
                }

                damage = damages[index];


                damage.formReceived = damage.docs && damage.docs.length && damage.docs.filter(function (doc) {
                  return doc.what && doc.what.value === "DO3";
                }).length ? true : false;

                reporterName = "";

                if (!damage.decosiInfo) {
                  _context8.next = 217;
                  break;
                }

                reporterName = "code client/inconnu";

                if (!(damage.decosiInfo && damage.decosiInfo.reporter && damage.decosiInfo.reporter.id)) {
                  _context8.next = 215;
                  break;
                }

                _context8.next = 214;
                return UsersService.getNameById(damage.decosiInfo.reporter.id);

              case 214:
                reporterName = _context8.sent;

              case 215:
                _context8.next = 221;
                break;

              case 217:
                if (!damage.creationUserId) {
                  _context8.next = 221;
                  break;
                }

                _context8.next = 220;
                return UsersService.getNameById(damage.creationUserId);

              case 220:
                reporterName = _context8.sent;

              case 221:
                damage.creationUserName = reporterName;

                if (!damage.lastUserId) {
                  _context8.next = 227;
                  break;
                }

                _context8.next = 225;
                return UsersService.getById(damage.lastUserId);

              case 225:
                user = _context8.sent;

                if (user) {
                  damage.lastUserName = UsersService.getName(user);
                }

              case 227:

                damage.docsSent = 0;
                damage.docsNotSent = 0;
                if (damage.docs) {
                  _docsSentList = damage.docs.filter(function (doc) {
                    return doc.insurerTransmissionDate;
                  });

                  damage.docsSent = _docsSentList.length;
                  damage.docsNotSent = damage.docs.length - damage.docsSent;
                }
                damage.insurerDocs = damage.docsSent + "/" + (damage.docsSent + damage.docsNotSent);

                damage.btEdit = {
                  text: '<i class="fa fa-edit"></i> Modifier',
                  color: "custom"
                };
                damage.btSee = {
                  text: '<i class="fa fa-file"></i> Fiche récap.',
                  color: "custom"
                };

                if (damage.insurer && damage.insurer.refInsurer) {
                  damage.insurerRefInsurer = damage.insurer.refInsurer;
                }

                _context8.next = 236;
                return CustomListsService.getNameByValue("typeDamageStatus", damage.typeDamageStatus);

              case 236:
                damage.typeDamageStatusName = _context8.sent;
                _context8.next = 239;
                return GroupsService.getById(damage.groupId);

              case 239:
                group = _context8.sent;


                //console.log("find group :", group);

                if (group.backgroundColor) {
                  damage.backgroundColor = group.backgroundColor;
                }

                _context8.next = 243;
                return GroupsService.getNameById(damage.groupId);

              case 243:
                damage.groupName = _context8.sent;


                if (damage.dateDamage) {
                  dateDommage = moment(damage.dateDamage);

                  damage.year = dateDommage.year();
                  damage.month = dateDommage.format("MMMM");
                  damage.day = dateDommage.format("dddd");
                }

                lal = lalsByRef.get(damage._id);

                if (!(lal && lal.groupId)) {
                  _context8.next = 250;
                  break;
                }

                _context8.next = 249;
                return GroupsService.getNameById(lal.groupId);

              case 249:
                lal.groupName = _context8.sent;

              case 250:

                if (lal && lal.damageIds.length && lal.damageIds.includes(damage._id)) {
                  damage.refLal = lal.refInsurer;
                  if (lal.costTotal || lal.costTotal === 0) {
                    damage.costTotalLal = Math.round(lal.costTotal * 100) / 100;
                  }
                  damage.statusLal = lal.statusInsurer;
                } else {
                  console.log("lal not found");
                }

                damage.oldCostProvision = damage.costProvision;
                damage.newCostInsurer = 0;
                if (damage.costTotalLal || damage.costTotalLal === 0) {
                  damage.newCostInsurer += damage.costTotalLal;
                  delete damage.costProvision;
                } else {
                  if (damage.costProvision) {
                    damage.newCostInsurer += damage.costProvision;
                  }
                }

                damage.newCostCompagny = 0;
                // Ici la franchise LAL est toujours mise par défaut à 0 dans l'import LAL
                if (lal && lal.costDeductible) {
                  damage.newCostCompagny += lal.costDeductible;
                  damage.costDeductible = lal.costDeductible;
                } else if (damage.costDeductible) {
                  damage.newCostCompagny += damage.costDeductible;
                }
                if (damage.costThirdParty) {
                  damage.newCostCompagny += damage.costThirdParty;
                }
                if (damage.costInternal) {
                  damage.newCostCompagny += damage.costInternal;
                }
                if (damage.refundThirdParty) {
                  damage.newCostCompagny -= damage.refundThirdParty;
                }

                damage.newCostTotal = damage.newCostCompagny + damage.newCostInsurer;

                damage.newCostTotal = Math.round(damage.newCostTotal * 100) / 100;
                damage.newCostCompagny = Math.round(damage.newCostCompagny * 100) / 100;
                damage.newCostInsurer = Math.round(damage.newCostInsurer * 100) / 100;

                if (!damage.dateDamage) {
                  _context8.next = 290;
                  break;
                }

                _context8.next = 266;
                return UsersService.getById(damage.driverId);

              case 266:
                _driver = _context8.sent;

                if (!(damage.driverId && _driver)) {
                  _context8.next = 284;
                  break;
                }

                damage.nbDamages = _driver.nbDamages;
                damage.driverNbDispute100 = _driver.nbDispute100;
                damage.driverNbDispute50 = _driver.nbDispute50;
                damage.driverNbDispute0 = _driver.nbDispute0;

                damage.driverName = UsersService.getName(_driver);
                damage.driverToCheck = _driver.toCheck;
                damage.driverInternalName = _driver.internalNumber;
                damage.defaultManagerId = _driver.defaultManagerId;

                damage.driverSeniority = _driver.startDate ? moment(damage.dateDamage).diff(moment(_driver.startDate), "months") : "";

                damage.driverExternalCompany = _driver.externalCompany;

                if (!_driver.contract) {
                  _context8.next = 283;
                  break;
                }

                _context8.next = 281;
                return CustomListsService.getNameByValue("typeContract", _driver.contract);

              case 281:
                type = _context8.sent;


                damage.driverContract = type;

              case 283:
                damage.driver = _driver;

              case 284:
                typeOfInjuryData = typeOfInjuryList.find(function (item) {
                  return item.value === damage.typeOfInjury;
                });

                if (typeOfInjuryData) {
                  damage.typeOfInjuryName = typeOfInjuryData.name;
                } else {
                  damage.typeOfInjuryName = "";
                }

                typeOfAccidentData = typeOfAccidentList.find(function (item) {
                  return item.value === damage.typeOfAccident;
                });

                if (typeOfAccidentData && typeOfAccidentData.data) {
                  typeOfAccident = JSON.parse(typeOfAccidentData.data);

                  damage.typeOfAccidentName = typeOfAccidentData.name.split(" (")[0];
                } else {
                  damage.typeOfAccidentName = "???";
                }

                severityDamageData = severityDamageList.find(function (item) {
                  return item.value === damage.severityDamage;
                });

                if (severityDamageData) {
                  damage.severityDamageName = severityDamageData.name;
                }

              case 290:

                damage.pourcentageDispute = typeof damage.pourcentageDispute !== "undefined" && damage.pourcentageDispute !== null && ["0", "50", "100"].includes(damage.pourcentageDispute.toString()) ? damage.pourcentageDispute.toString() + " %" : "";

                damage.lalPourcentageDispute = lal ? lal.pourcentageDispute : "";

                if (!damage.informManager || !damage.informManager.emails) {
                  damage.btManager = {
                    text: '<i class="fa fa-exclamation"></i> À informer',
                    color: "custom-warning"
                  };
                } else {
                  // let text;
                  // if (damage.informManager.emails.length >= 25) {  // damage.informManager.emails -> string
                  //   text = damage.informManager.emails.substring(0, 22) + "...";
                  // } else {
                  //   text = damage.informManager.emails;
                  // }
                  onlyUnique = function onlyUnique(value, index, array) {
                    return array.indexOf(value) === index;
                  };

                  text = damage.informManager.emails.split(",").filter(onlyUnique).length + " informé(s)";

                  damage.btManager = {
                    text: '<i class="fa fa-check-circle"></i> ' + text,
                    color: "custom"
                  };
                }

                if (!damage.managerId) {
                  _context8.next = 297;
                  break;
                }

                _context8.next = 296;
                return UsersService.getNameById(damage.managerId);

              case 296:
                damage.managerName = _context8.sent;

              case 297:
                _context8.next = 299;
                return CustomersService.getNameById(damage.customerId);

              case 299:
                damage.customerName = _context8.sent;
                _context8.next = 302;
                return VehiclesService.getById(damage.vehicleId);

              case 302:
                vehicle = _context8.sent;

                if (!(damage.vehicleId && vehicle)) {
                  _context8.next = 323;
                  break;
                }

                // external vehicle -> "Sans contrat"
                damage.vehicleName = VehiclesService.getName(vehicle);

                _context8.next = 307;
                return CustomListsService.getNameByValue("typeVehicleV2", vehicle.type);

              case 307:
                damage.vehicleType = _context8.sent;


                damage.vehicleToCheck = vehicle.toCheck;

                source = void 0;

                if (!(!damage.insurer || !damage.insurer.noReport)) {
                  _context8.next = 320;
                  break;
                }

                if (!vehicle.insurerContract) {
                  _context8.next = 318;
                  break;
                }

                _context8.next = 314;
                return InsurerContractsService.getById(vehicle.insurerContract);

              case 314:
                damage.insurerContract = _context8.sent;

                source = "véhicule";
                _context8.next = 320;
                break;

              case 318:
                damage.insurerContract = insurerDefaultContract;
                source = "par défaut";

              case 320:

                if (damage.insurer && damage.insurer.contractName) {
                  damage.insurerContractName = damage.insurer.contractName;
                } else if (damage.insurer && damage.insurer.noReport) {
                  damage.insurerContractName = "";
                } else if (damage.insurerContract && !damage.insurerContract.name) {
                  console.log("insurerContract not found : check vehicle " + damage.vehicleName, damage.insurerContract);
                  damage.insurerContractName = "Vérifier le contrat " + source;
                } else {
                  damage.insurerContractName = damage.insurerContract ? damage.insurerContract.name + " / " + damage.insurerContract.company + " (" + source + ")" : "???";
                }
                _context8.next = 324;
                break;

              case 323:
                damage.vehicleName = damage.externalVehicleName;

              case 324:

                if (!(damage.insurerContract && damage.insurer && (damage.insurer.dateReport || damage.insurer.refInsurer))) {
                  damage.btDelete = {
                    text: '<i class="fa fa-trash"></i> Suppr.',
                    color: "custom-danger"
                  };
                }

                if (damage.refInsurer) {
                  damage.refCheckInsurer = true;
                } else {
                  damage.refCheckInsurer = false;
                }
                if (vm.customer.eadPartner === "autogriff" || vm.customer.eadPartner === "custom" && vm.customer.eadPartnerEmail) {
                  if (damage.damageExpertCostHT || damage.damageExpertCostHT === 0) {
                    damage.btEadPage = {
                      text: "<i class=\"fa fa-check\"></i> Chiffrage re\xE7u : " + damage.damageExpertCostHT + " \u20AC HT",
                      color: "custom"
                    };
                  } else if (damage.eadResponseStatus && damage.eadResponseStatus === 201) {
                    damage.btEadPage = {
                      text: '<i class="fa fa-check"></i> Chiffrage demandé',
                      color: "custom-success"
                    };
                    if (vm.customer.eadPartner !== "autogriff") {
                      damage.btEadResend = {
                        text: '<i class="fa fa-paper-plane"></i> Renvoyer la demande au chiffreur',
                        color: "custom-warning"
                      };
                    }
                  } else if (!damage.insurer || !damage.insurer.dateReport) {
                    damage.btEadPage = {
                      text: '<i class="fa fa-paper-plane"></i> Ouvrir la page du chiffrage',
                      color: "custom-warning"
                    };
                    damage.btEadLink = {
                      text: '<i class="fa fa-external-link"></i> Envoyer le lien au collaborateur',
                      color: "custom-warning"
                    };
                    if (damage.eadResponseStatus && vm.customer.eadPartner !== "autogriff") {
                      damage.btEadResend = {
                        text: '<i class="fa fa-paper-plane"></i> Renvoyer la demande au chiffreur',
                        color: "custom-warning"
                      };
                    }
                  }
                }

                if ((!damage.insurer || damage.insurer && !damage.insurer.dateReport && damage.insurer.noReport !== true) &&
                // Jamais déclarer à l'assureur via EDI si Autogriff
                vm.customer.eadPartner === "autogriff") {
                  // No insurer button
                } else if (damage.insurer && damage.insurer.noReport === true) {
                  damage.btInsurer = {
                    text: '<i class="fa fa-ban"></i> Non déclaré',
                    color: "custom-info"
                  };
                } else {
                  if (damage.insurer && (damage.insurer.dateReport || damage.insurer.refInsurer)) {
                    if (damage.insurer.dateReport) {
                      damage.dateInsurerReport = damage.insurer.dateReport;
                    }

                    if (damage.insurer.refInsurer) {
                      damage.statusEdi = "Enregistré";
                      damage.btInsurer = {
                        text: '<i class="fa fa-check-circle"></i> Enregistré',
                        color: "custom"
                      };
                    } else if (damage.doSendToVerlingue) {
                      damage.statusEdi = "Transmission en cours";
                      damage.btInsurer = {
                        text: '<i class="fa fa-check"></i> Transmission en cours',
                        color: "custom-success"
                      };
                    } else {
                      damage.statusEdi = "Transmis";
                      damage.btInsurer = {
                        text: '<i class="fa fa-check"></i> Transmis',
                        color: "custom-success"
                      };
                    }
                    // replace btInsurer if some docs not sent
                    if (damage.docsNotSent > 0) {
                      damage.btInsurer = {
                        text: '<i class="fa fa-paper-plane"></i> À compléter',
                        color: "custom-warning"
                      };
                    }
                  } else {
                    if (damage.insurerContract) {
                      damage.btInsurer = {
                        text: '<i class="fa fa-paper-plane"></i> Transmettre',
                        color: "custom-warning"
                      };
                    } else {
                      damage.btInsurer = {
                        text: '<i class="fa fa-exclamation"></i> Sans contrat',
                        color: "custom-warning"
                      };
                    }
                  }
                }

                damage.costGroup = damage.costDamage;

                if (!damage.drivingLicenceValid) {
                  _context8.next = 339;
                  break;
                }

                _context8.t8 = damage.drivingLicenceValid;
                _context8.next = _context8.t8 === "1" ? 333 : _context8.t8 === "0" ? 335 : 337;
                break;

              case 333:
                damage.drivingLicenceValid = true;
                return _context8.abrupt("break", 339);

              case 335:
                damage.drivingLicenceValid = false;
                return _context8.abrupt("break", 339);

              case 337:
                delete damage.drivingLicenceValid;
                return _context8.abrupt("break", 339);

              case 339:

                vm.rawData.push(damage);
                if (damage.typeDamageStatus === "close") {
                  vm.rawDataClosed.push(damage);
                } else {
                  vm.rawDataOpened.push(damage);
                }

              case 341:
                index++;
                _context8.next = 205;
                break;

              case 344:

                $timeout(function () {
                  vm.needLalsToBeUpdate = true;
                  vm.needToBeUpdate = true;
                }, 10);
                _context8.next = 350;
                break;

              case 347:
                _context8.prev = 347;
                _context8.t9 = _context8["catch"](3);

                console.error("refresh", _context8.t9);

              case 350:
                Notiflix.Loading.remove();

              case 351:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this, [[3, 347], [27, 34], [45, 52], [133, 137, 141, 149], [142,, 144, 148], [154, 188, 192, 200], [164, 168, 172, 180], [173,, 175, 179], [193,, 195, 199]]);
      }));

      return function (_x6) {
        return _ref8.apply(this, arguments);
      };
    }();

    vm.displayInfo = function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(damage) {
        var source, reporterName, accidentValues, glassValues, horsAccidentValues, explicitValues, commentDetails, emails, costInsurerRows, forms;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                source = READ_SUMMARY_URL + "/";
                reporterName = "";

                if (!damage.decosiInfo) {
                  _context9.next = 10;
                  break;
                }

                reporterName = "code client/inconnu";

                if (!(damage.decosiInfo && damage.decosiInfo.reporter && damage.decosiInfo.reporter.id)) {
                  _context9.next = 8;
                  break;
                }

                _context9.next = 7;
                return UsersService.getNameById(damage.decosiInfo.reporter.id);

              case 7:
                reporterName = _context9.sent;

              case 8:
                _context9.next = 14;
                break;

              case 10:
                if (!damage.creationUserId) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 13;
                return UsersService.getNameById(damage.creationUserId);

              case 13:
                reporterName = _context9.sent;

              case 14:
                accidentValues = ["circulation", "maneuver"];
                glassValues = ["glass"];
                horsAccidentValues = ["parking", "theft", "disaster", "fire", "handling", "repair", "building"];
                explicitValues = [].concat(accidentValues, glassValues, horsAccidentValues);
                commentDetails = "Sinistre n\xB0" + damage.name + " (" + (damage.typeOfAccidentName ? damage.typeOfAccidentName : "???") + ") du " + moment(damage.dateDamage).format("DD/MM/YYYY") + " du collaborateur " + damage.driverName + " " + (explicitValues.includes(damage.typeOfAccident) ? "avec le véhicule " + damage.vehicleName : "") + " : " + damage.circumstance;

                if (!(vm.isAdmin == true || vm.isLvr == true)) {
                  _context9.next = 25;
                  break;
                }

                _context9.next = 22;
                return EmailHistoryService.find({
                  filter: {
                    where: {
                      $or: [{ damageId: { $eq: damage._id } }, { _damageId: { $eq: damage._id } }]
                    },
                    fields: ["_id", "customerId", "from", "to", "cc", "bcc", "creationDate", "subject", "readDate", "status", "reports", "report", "phone", "smsStatus", "smsText", "triggeredBy", "error", "html"],
                    order: { creationDate: -1 }
                  }
                });

              case 22:
                _context9.t0 = _context9.sent;
                _context9.next = 26;
                break;

              case 25:
                _context9.t0 = [];

              case 26:
                emails = _context9.t0;
                costInsurerRows = [];

                if (damage.costTotalLal || damage.costTotalLal === 0) {
                  costInsurerRows = [{
                    titleBefore: "Coûts Assureur =",
                    label: "Coût transmis par l'assureur à LVR",
                    value: damage.costTotalLal + " €"
                  }];
                } else {
                  costInsurerRows = [{
                    titleBefore: "Coûts Assureur =",
                    label: "Estimation par le client",
                    value: damage.costProvision ? damage.costProvision + " €" : ""
                  }];
                }

                _context9.t1 = ["Fiche courte", "Fiche longue"];
                _context9.t2 = {
                  label: "Référence",
                  value: damage.name
                };
                _context9.t3 = {
                  label: "Ne pas déclarer à l'assureur",
                  value: damage.insurer && damage.insurer.noReport ? "Non déclaré" : ""
                };
                _context9.t4 = {
                  label: "Déclaré le",
                  value: moment(damage.creationDate).format("DD/MM/YYYY")
                };
                _context9.t5 = {
                  label: "Déclaré par",
                  value: reporterName
                };
                _context9.t6 = {
                  label: "Modifié le",
                  value: damage.lastUserModificationDate ? moment(damage.lastUserModificationDate).format("DD/MM/YYYY") : ""
                };

                if (!damage.lastUserId) {
                  _context9.next = 41;
                  break;
                }

                _context9.next = 38;
                return UsersService.getNameById(damage.lastUserId);

              case 38:
                _context9.t7 = _context9.sent;
                _context9.next = 42;
                break;

              case 41:
                _context9.t7 = "";

              case 42:
                _context9.t8 = _context9.t7;
                _context9.t9 = {
                  label: "Modifié par",
                  value: _context9.t8
                };
                _context9.t10 = {
                  label: "Groupe associé",
                  value: damage.groupName
                };
                _context9.t11 = {
                  label: "Responsable du suivi du dossier",
                  value: damage.managerName
                };
                _context9.t12 = {
                  label: "Date d'ouverture",
                  value: damage.dateOpenDispute ? moment(damage.dateOpenDispute).format("DD/MM/YYYY") : ""
                };
                _context9.t13 = {
                  label: "Date de clôture",
                  value: damage.dateCloseDispute ? moment(damage.dateCloseDispute).format("DD/MM/YYYY") : ""
                };
                _context9.t14 = {
                  label: "Statut du dossier",
                  value: damage.typeDamageStatusName
                };
                _context9.t15 = {
                  label: "Statut assureur",
                  value: damage.lalStatusInsurer
                };
                _context9.t16 = {
                  label: "Classification interne",
                  value: damage.customClassification
                };
                _context9.t17 = {
                  label: "Réf. provisoire assureur",
                  value: damage.refInsurer
                };
                _context9.t18 = {
                  label: "Réf. assureur",
                  value: damage.lalRefInsurer
                };
                _context9.t19 = {
                  label: "Réf. saisie par l'assureur/courtier",
                  value: damage.insurerRefInsurer
                };
                _context9.t20 = {
                  label: "Date de la dernière action",
                  value: damage.dateLastAction ? moment(damage.dateLastAction).format("DD/MM/YYYY") : ""
                };
                _context9.t21 = {
                  label: "Action menée",
                  value: damage.lastAction
                };
                _context9.t22 = {
                  label: "Action vers",
                  value: damage.contactLastAction
                };
                _context9.t23 = {
                  label: "Actions à mener",
                  value: damage.nextAction
                };
                _context9.t24 = [_context9.t2, _context9.t3, _context9.t4, _context9.t5, _context9.t6, _context9.t9, _context9.t10, _context9.t11, _context9.t12, _context9.t13, _context9.t14, _context9.t15, _context9.t16, _context9.t17, _context9.t18, _context9.t19, _context9.t20, _context9.t21, _context9.t22, _context9.t23];
                _context9.t25 = {
                  name: "Suivi du dossier",
                  filters: _context9.t1,
                  lines: _context9.t24
                };
                _context9.t26 = {
                  name: "Collaborateur sinistré",
                  filters: ["Fiche courte", "Fiche longue"],
                  lines: [{
                    label: "Nom Prénom",
                    value: damage.driverName
                  }, {
                    label: "Date du dernier sinistre",
                    value: damage.driver.lastDamageDate ? moment(damage.driver.lastDamageDate).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Nombre de sinistres",
                    value: damage.driver.nbDamages || 0
                  }, {
                    label: "Nombre de sinistres 100% resp.",
                    value: damage.driverNbDispute100 || 0
                  }, {
                    label: "Nombre de sinistres 50% resp.",
                    value: damage.driverNbDispute50 || 0
                  }, {
                    label: "Nombre de sinistres 0% resp.",
                    value: damage.driverNbDispute0 || 0
                  }]
                };
                _context9.t27 = {
                  name: "Véhicule",
                  filters: ["Fiche courte", "Fiche longue"],
                  lines: [{
                    label: "Véhicule",
                    value: damage.vehicleName
                  }, {
                    label: "Type de véhicule",
                    value: damage.vehicleType
                  }, {
                    label: "Gravité des dommages",
                    value: damage.severityDamageName
                  }, {
                    label: "Kilométrage relevé au moment du sinistre",
                    value: damage.mileage
                  }, {
                    label: "N° Remorque",
                    value: damage.trailerName
                  }, {
                    label: "Remorque abimée",
                    value: damage.trailerDamaged ? "Oui" : ""
                  }, {
                    label: "N° Conteneur",
                    value: damage.containerName
                  }, {
                    label: "Conteneur abimé",
                    value: damage.containerDamaged ? "Oui" : ""
                  }, {
                    label: "N° de la tournée ou N° de l'OT",
                    value: damage.tourNumber
                  }, {
                    label: "Client lié à la tournée ou à l'OT",
                    value: damage.tourCustomer
                  }, {
                    titleBefore: "Réparateur",
                    label: "Nom du réparateur",
                    value: damage.repairerInfo
                  }, {
                    label: "Coordonnées du réparateur",
                    value: damage.repairerAddress
                  }]
                };
                _context9.t28 = {
                  name: "Circonstances",
                  filters: ["Fiche courte", "Fiche longue"],
                  lines: [{
                    label: "Date de survenance",
                    value: damage.dateDamage ? moment(damage.dateDamage).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Lieu de survenance",
                    value: damage.location
                  }, {
                    label: "Type de sinistre",
                    value: damage.typeOfAccidentName
                  }, {
                    label: "Responsabilité présumée",
                    value: damage.pourcentageDispute
                  }, {
                    label: "Responsabilité assureur",
                    value: damage.lalPourcentageDispute
                  }, {
                    label: "Description du sinistre",
                    value: damage.circumstance
                  }, {
                    label: "Blessé(s) même léger(s) ?",
                    value: damage.withInjury ? "Oui" : ""
                  }, {
                    label: "Qui a été blessé ?",
                    value: damage.typeOfInjuryName,
                    hidden: !damage.withInjury
                  }, {
                    label: "Avec tiers",
                    value: damage.withThirdParty ? "Oui" : ""
                  }, {
                    label: "Nom du tiers",
                    value: damage.thirdPartyDriverName,
                    hidden: !damage.withThirdParty
                  }, {
                    label: "Société du tiers",
                    value: damage.thirdPartyCompagnyName,
                    hidden: !damage.withThirdParty
                  }, {
                    label: "Assureur du tiers",
                    value: damage.thirdPartyAssurerName,
                    hidden: !damage.withThirdParty
                  }, {
                    label: "Commentaires",
                    value: damage.comment
                  }, {
                    label: "Constat reçu",
                    value: damage.formReceived ? "Oui" : "Non"
                  }]
                };
                _context9.t29 = {
                  name: "Coûts",
                  filters: ["Fiche longue"],
                  lines: [{
                    label: "Coût total du sinistre",
                    value: damage.newCostTotal ? damage.newCostTotal + " €" : ""
                  }, {
                    titleBefore: "Coût total du sinistre =",
                    label: "Coût à notre charge",
                    value: damage.newCostCompagny ? damage.newCostCompagny + " €" : ""
                  }, {
                    label: "+ Coût Assureur",
                    value: damage.newCostInsurer ? damage.newCostInsurer + " €" : ""
                  }, {
                    titleBefore: "Coûts à notre charge =",
                    label: "Franchise / Auto Assurance",
                    value: damage.costDeductible ? damage.costDeductible + " €" : ""
                  }, {
                    label: "+ Réparations véhicule flotte / Provision FRE",
                    value: damage.costInternal ? damage.costInternal + " €" : ""
                  }, {
                    label: "+ Indemnisation tiers",
                    value: damage.costThirdParty ? damage.costThirdParty + " €" : ""
                  }, {
                    label: "- Remboursement par le tiers",
                    value: damage.refundThirdParty ? damage.refundThirdParty + " €" : ""
                  }].concat(_toConsumableArray(costInsurerRows), [{
                    titleBefore: "Estimation des réparations",
                    label: "Montant estimé des réparations (HT)",
                    value: damage.estimateAmountHT ? damage.estimateAmountHT + " €" : ""
                  }, {
                    label: "Montant estimé des dommages non réparés (HT)",
                    value: damage.estimateAmountNotRepairedHT ? damage.estimateAmountNotRepairedHT + " €" : ""
                  }, {
                    titleBefore: "Expertise",
                    label: "Date de l'expertise",
                    value: damage.dateReport ? moment(damage.dateReport).format("DD/MM/YYYY") : ""
                  }, {
                    label: "Nom/Société de l'expert",
                    value: damage.expertName
                  }, {
                    label: "Montant de l'expertise (HT)",
                    value: damage.damageExpertCostHT ? damage.damageExpertCostHT + " €" : ""
                  }, {
                    titleBefore: "Autre",
                    label: "Accord amiable",
                    value: damage.aggreement ? "Oui" : ""
                  }, {
                    label: "Montant retenu pour calcul prime",
                    value: damage.costRelatedToDriver ? damage.costRelatedToDriver + " €" : ""
                  }, {
                    label: "Malus prime",
                    value: damage.malusDriverAmount
                  }, {
                    label: "Notes",
                    value: damage.costNotes
                  }])
                };
                _context9.t30 = {
                  name: "Devis des réparations",
                  filters: ["Fiche longue"],
                  lines: [{
                    titleBefore: "Devis des réparations du véhicule",
                    label: "Montant du devis",
                    value: damage.quoteVehicle ? damage.quoteVehicle + " €" : ""
                  }, {
                    label: "Société",
                    value: damage.quoteVehicleCompany
                  }, {
                    label: "Notes",
                    value: damage.quoteVehicleNote
                  }, {
                    titleBefore: "Devis des réparations de la remorque",
                    label: "Montant du devis",
                    value: damage.quoteTrailer ? damage.quoteTrailer + " €" : ""
                  }, {
                    label: "Société",
                    value: damage.quoteTrailerCompany
                  }, {
                    label: "Notes",
                    value: damage.quoteTrailerNote
                  }, {
                    titleBefore: "Devis des réparations diverses",
                    label: "Montant du devis",
                    value: damage.quoteOther ? damage.quoteOther + " €" : ""
                  }, {
                    label: "Société",
                    value: damage.quoteOtherCompany
                  }, {
                    label: "Notes",
                    value: damage.quoteOtherNote
                  }, {
                    titleBefore: "Devis des réparations du tiers",
                    label: "Montant du devis",
                    value: damage.quoteThirdParty ? damage.quoteThirdParty + " €" : ""
                  }, {
                    label: "Société",
                    value: damage.quoteThirdPartyCompany
                  }, {
                    label: "Notes",
                    value: damage.quoteThirdPartyNote
                  }]
                };
                _context9.t31 = {
                  name: "Remboursements",
                  filters: ["Fiche longue"],
                  lines: [{
                    label: "Notes",
                    value: damage.reInvoicingNote
                  }, {
                    titleBefore: "Remboursement #1",
                    label: "Montant",
                    value: damage.reInvoicingAmount1 ? damage.reInvoicingAmount1 + " €" : ""
                  }, {
                    label: "N° de facture",
                    value: damage.reInvoicingNumber1
                  }, {
                    label: "Type de société",
                    value: damage.reInvoicingCompanyType1
                  }, {
                    label: "Société",
                    value: damage.reInvoicingCompany1
                  }, {
                    label: "Accord ?",
                    value: damage.reInvoicingAggreement1 ? "Oui" : ""
                  }, {
                    label: "Réglée ?",
                    value: damage.reInvoicingPaid1 ? "Oui" : ""
                  }, {
                    titleBefore: "Remboursement #2",
                    label: "Montant",
                    value: damage.reInvoicingAmount2 ? damage.reInvoicingAmount2 + " €" : ""
                  }, {
                    label: "N° de facture",
                    value: damage.reInvoicingNumber2
                  }, {
                    label: "Type de société",
                    value: damage.reInvoicingCompanyType2
                  }, {
                    label: "Société",
                    value: damage.reInvoicingCompany2
                  }, {
                    label: "Accord ?",
                    value: damage.reInvoicingAggreement2 ? "Oui" : ""
                  }, {
                    label: "Réglée ?",
                    value: damage.reInvoicingPaid2 ? "Oui" : ""
                  }, {
                    titleBefore: "Remboursement #3",
                    label: "Montant",
                    value: damage.reInvoicingAmount3 ? damage.reInvoicingAmount3 + " €" : ""
                  }, {
                    label: "N° de facture",
                    value: damage.reInvoicingNumber3
                  }, {
                    label: "Type de société",
                    value: damage.reInvoicingCompanyType3
                  }, {
                    label: "Société",
                    value: damage.reInvoicingCompany3
                  }, {
                    label: "Accord ?",
                    value: damage.reInvoicingAggreement3 ? "Oui" : ""
                  }, {
                    label: "Réglée ?",
                    value: damage.reInvoicingPaid3 ? "Oui" : ""
                  }]
                };
                _context9.t32 = {
                  name: "Documents",
                  filters: ["Fiche longue", "Documents"],
                  lines: [{
                    label: "Documents à transmettre à l'assureur",
                    value: damage.docs
                  }, {
                    label: "Documents internes",
                    value: damage.docsBilling
                  }]
                };
                forms = [_context9.t25, _context9.t26, _context9.t27, _context9.t28, _context9.t29, _context9.t30, _context9.t31, _context9.t32];
                _context9.next = 70;
                return DamagesService.getHistory(damage._id);

              case 70:
                damage.history = _context9.sent;


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Fiche récapitulative",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  message: {
                    emails: emails,
                    object: damage,
                    customerName: damage.customerName,
                    titleName: "Sinistre n°" + damage.name,
                    headerName: "Fiche récapitulative sinistre",
                    footerName: "Sinistre n°" + damage.name,
                    fileName: "Fiche r\xE9cap - " + damage.driverName + " - Sinistre du " + moment(damage.dateDamage).format("DD-MM-YYYY"),
                    commentDetails: commentDetails,
                    filters: ["Fiche courte", "Fiche longue", "Documents"],
                    signatureFilters: ["Fiche courte", "Fiche longue"],
                    forms: forms,
                    videos: [].concat(_toConsumableArray(damage.docs || []), _toConsumableArray(damage.docsBilling || [])).filter(function (doc) {
                      return doc.url.match(/\.(mp4|webm|ogg)(\?.*)?$/i);
                    })
                  }
                }).then(function () {
                  console.log("close modal");
                }).catch(function (err) {
                  console.error("err", err);
                });

              case 72:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function (_x7) {
        return _ref9.apply(this, arguments);
      };
    }();

    vm.openDocsInsurer = function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(damage) {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return ModalService.openComponent("docs-insurer", {
                  damage: damage,
                  size: "lg"
                });

              case 2:

                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return vm.refresh();

                        case 2:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10, _this);
                })), 10);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this);
      }));

      return function (_x8) {
        return _ref10.apply(this, arguments);
      };
    }();

    vm.informInsurer = function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(damage) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                console.log("inform insurer", damage);

                if (!(damage.insurer && damage.insurer.dateReport)) {
                  _context13.next = 6;
                  break;
                }

                _context13.next = 4;
                return vm.openDocsInsurer(damage);

              case 4:
                _context13.next = 19;
                break;

              case 6:
                if (!(damage.insurer && damage.insurer.noReport === true)) {
                  _context13.next = 11;
                  break;
                }

                _context13.next = 9;
                return swal("", "L'envoi à l'assurance est bloqué. \n\n Editer le sinistre si besoin pour autoriser la transmission", "info");

              case 9:
                _context13.next = 19;
                break;

              case 11:
                if (!damage.insurerContract) {
                  _context13.next = 17;
                  break;
                }

                _context13.next = 14;
                return ModalService.openComponent("perform-insurer-edi", {
                  damage: damage,
                  size: "lg"
                });

              case 14:

                $timeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                  return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return vm.refresh();

                        case 2:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12, _this);
                })), 10);
                _context13.next = 19;
                break;

              case 17:
                _context13.next = 19;
                return swal("", "Aucun contrat n'a été associé à ce véhicule et aucun contrat par défaut n'a été renseigné.", "info");

              case 19:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this);
      }));

      return function (_x9) {
        return _ref12.apply(this, arguments);
      };
    }();

    vm.informManager = function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(damage, manager) {
        var response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                console.log("inform manager", damage, manager);
                Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");

                _context14.prev = 2;
                _context14.next = 5;
                return DamagesService.customPost("informManager", {
                  damageId: damage._id,
                  managerIdToInform: manager
                });

              case 5:
                response = _context14.sent;

                if (!(response && response.emails && response.success)) {
                  _context14.next = 13;
                  break;
                }

                Notiflix.Notify.success("Envoi réussi");
                _context14.next = 10;
                return vm.refresh();

              case 10:
                return _context14.abrupt("return", response.emails);

              case 13:
                Notiflix.Notify.failure("Echec de l'envoi");
                return _context14.abrupt("return", null);

              case 15:
                _context14.next = 21;
                break;

              case 17:
                _context14.prev = 17;
                _context14.t0 = _context14["catch"](2);

                Notiflix.Notify.failure("Echec de l'envoi");
                return _context14.abrupt("return", null);

              case 21:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this, [[2, 17]]);
      }));

      return function (_x10, _x11) {
        return _ref14.apply(this, arguments);
      };
    }();

    vm.informManagerModal = function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(damage) {
        var noRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return ModalService.openComponent("inform-manager", {
                  damage: damage,
                  size: "lg"
                }).then(function () {
                  var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(manager) {
                    var email;
                    return regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            vm.log("close modal");

                            if (!manager) {
                              _context15.next = 17;
                              break;
                            }

                            Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                            _context15.next = 5;
                            return vm.informManager(damage, manager);

                          case 5:
                            email = _context15.sent;

                            if (!email) {
                              _context15.next = 14;
                              break;
                            }

                            _context15.next = 9;
                            return swal("", "Un mail a été envoyé à " + email, "success");

                          case 9:
                            if (!(noRefresh !== true)) {
                              _context15.next = 12;
                              break;
                            }

                            _context15.next = 12;
                            return vm.refresh();

                          case 12:
                            _context15.next = 16;
                            break;

                          case 14:
                            _context15.next = 16;
                            return swal("", "Le manageur n'a pas pu être prévenu. Vérifier que cette personne a bien une adresse mail valide.", "error");

                          case 16:
                            if (noRefresh !== true) {
                              Notiflix.Loading.remove();
                            }

                          case 17:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15, this);
                  }));

                  return function (_x14) {
                    return _ref16.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  vm.log("err", err);
                });

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this);
      }));

      return function (_x12) {
        return _ref15.apply(this, arguments);
      };
    }();

    vm.scheduleDepa = function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(row) {
        var keyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var noRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var openModal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var damage, confirmDownload, schedule, oldPhoneToUse, oldEmailToUse, emails, customer, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, position, manager, _manager, _manager2, _manager3, _manager4, _manager5, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, leadId, lead, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, drmRespId, drmResp, _manager6, _manager7, managerN2, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, userId, user, _customer, nextReminder, _emails, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _position, _manager8, _manager9, _manager10, _manager11, _manager12, _manager13, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, _leadId, _lead, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, _drmRespId, _drmResp, _manager14, _manager15, _managerN, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _userId, _user, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _position2, _manager16, _manager17, _manager18, _manager19, _manager20, _manager21, _iteratorNormalCompletion13, _didIteratorError13, _iteratorError13, _iterator13, _step13, _leadId2, _lead2, _iteratorNormalCompletion14, _didIteratorError14, _iteratorError14, _iterator14, _step14, _drmRespId2, _drmResp2, _manager22, _manager23, _managerN2, _iteratorNormalCompletion15, _didIteratorError15, _iteratorError15, _iterator15, _step15, _userId2, _user2, container, buttonText, text, button, confirmSend, allowSave, phoneMobileRegex, emailRegex, _iteratorNormalCompletion16, _didIteratorError16, _iteratorError16, _iterator16, _step16, email, values, response;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                damage = angular.copy(row);


                damage.depa.emailToUse = damage.depa.emailToUse ? damage.depa.emailToUse.replace(/\s+/g, "") : null;

                if (!damage.depaId) {
                  _context19.next = 663;
                  break;
                }

                if (!(damage.depa.status === "Effectué")) {
                  _context19.next = 14;
                  break;
                }

                _context19.next = 7;
                return swal({
                  text: "Voulez-vous t\xE9l\xE9charger la fiche entretien du DEPA de " + damage.driverName + " ?",
                  icon: "info",
                  dangerMode: false,
                  buttons: ["Non", "Oui"]
                });

              case 7:
                confirmDownload = _context19.sent;

                if (!confirmDownload) {
                  _context19.next = 11;
                  break;
                }

                _context19.next = 11;
                return vm.openDepaReportPdf(damage);

              case 11:
                return _context19.abrupt("return");

              case 14:
                if (!(damage.depa.status === "Annulé" && !vm.isSuper)) {
                  _context19.next = 19;
                  break;
                }

                _context19.next = 17;
                return swal("", "Ce DEPA a été annulé.", "info");

              case 17:
                _context19.next = 661;
                break;

              case 19:
                if (!(damage.depa.missingCount && damage.depa.missingCount >= 3 && !vm.isSuper)) {
                  _context19.next = 24;
                  break;
                }

                _context19.next = 22;
                return swal("", "Le RDV a été manqué " + damage.depa.missingCount + " fois. La prise de RDV se fait désormais uniquement en contactant le support (02 41 59 00 00 ou support@lvr-fleet.fr).", "warning");

              case 22:
                _context19.next = 661;
                break;

              case 24:
                schedule = function () {
                  var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(damage) {
                    return regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            _context17.next = 2;
                            return ModalService.openComponent("schedule-depa", {
                              _id: damage.depa._id,
                              size: "lg",
                              keyboard: keyboard,
                              driver: damage.driver,
                              typeOfAccident: damage.typeOfAccident,
                              shortId: damage.depa.shortId,
                              phone: damage.depa.phone,
                              note: damage.depa.note,
                              slot: damage.depa.slot,
                              phoneToUse: damage.depa.phoneToUse,
                              emailToUse: damage.depa.emailToUse,
                              scheduleUserName: damage.depa.scheduleUserName,
                              damageManagerId: damage.managerId,
                              depaStatus: damage.depa.status,
                              depaMissingCount: damage.depa.missingCount
                            });

                          case 2:
                            if (!(noRefresh !== true)) {
                              _context17.next = 5;
                              break;
                            }

                            _context17.next = 5;
                            return vm.refresh();

                          case 5:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17, this);
                  }));

                  return function schedule(_x19) {
                    return _ref18.apply(this, arguments);
                  };
                }();

                if (!(damage.depa.status === "Annulé")) {
                  _context19.next = 217;
                  break;
                }

                oldPhoneToUse = damage.depa.phoneToUse;
                oldEmailToUse = damage.depa.emailToUse;
                emails = [];

                damage.depa.phoneToUse = null;

                _context19.next = 32;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 32:
                customer = _context19.sent;

                if (!customer.reminderByPositionCancel) {
                  _context19.next = 183;
                  break;
                }

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context19.prev = 37;
                _iterator4 = customer.reminderByPositionCancel[Symbol.iterator]();

              case 39:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context19.next = 169;
                  break;
                }

                position = _step4.value;

                if (!(position === "Conducteur")) {
                  _context19.next = 46;
                  break;
                }

                if (damage.driver.cellularPhone) {
                  damage.depa.phoneToUse = damage.driver.cellularPhone;
                }
                if (damage.driver.email) {
                  emails.push(damage.driver.email);
                }
                _context19.next = 166;
                break;

              case 46:
                if (!(position === "Manageur")) {
                  _context19.next = 53;
                  break;
                }

                _context19.next = 49;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 49:
                manager = _context19.sent;

                if (manager && manager.email) {
                  emails.push(manager.email);
                }
                _context19.next = 166;
                break;

              case 53:
                if (!(position === "RH")) {
                  _context19.next = 60;
                  break;
                }

                _context19.next = 56;
                return UsersService.getById(damage.driver.rhManagerId);

              case 56:
                _manager = _context19.sent;

                if (_manager && _manager.email) {
                  emails.push(_manager.email);
                }
                _context19.next = 166;
                break;

              case 60:
                if (!(position === "QSE")) {
                  _context19.next = 67;
                  break;
                }

                _context19.next = 63;
                return UsersService.getById(damage.driver.qseManagerId);

              case 63:
                _manager2 = _context19.sent;

                if (_manager2 && _manager2.email) {
                  emails.push(_manager2.email);
                }
                _context19.next = 166;
                break;

              case 67:
                if (!(position === "Gestionnaire Parc")) {
                  _context19.next = 74;
                  break;
                }

                _context19.next = 70;
                return UsersService.getById(damage.driver.fleetManagerId);

              case 70:
                _manager3 = _context19.sent;

                if (_manager3 && _manager3.email) {
                  emails.push(_manager3.email);
                }
                _context19.next = 166;
                break;

              case 74:
                if (!(position === "Autre responsable 1")) {
                  _context19.next = 81;
                  break;
                }

                _context19.next = 77;
                return UsersService.getById(damage.driver.other1ManagerId);

              case 77:
                _manager4 = _context19.sent;

                if (_manager4 && _manager4.email) {
                  emails.push(_manager4.email);
                }
                _context19.next = 166;
                break;

              case 81:
                if (!(position === "Autre responsable 2")) {
                  _context19.next = 88;
                  break;
                }

                _context19.next = 84;
                return UsersService.getById(damage.driver.other2ManagerId);

              case 84:
                _manager5 = _context19.sent;

                if (_manager5 && _manager5.email) {
                  emails.push(_manager5.email);
                }
                _context19.next = 166;
                break;

              case 88:
                if (!(position === "LEAD" && customer._leadIds && customer._leadIds.length)) {
                  _context19.next = 119;
                  break;
                }

                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context19.prev = 92;
                _iterator5 = customer._leadIds[Symbol.iterator]();

              case 94:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context19.next = 103;
                  break;
                }

                leadId = _step5.value;
                _context19.next = 98;
                return UsersService.getById(leadId);

              case 98:
                lead = _context19.sent;

                if (lead && lead.email) {
                  emails.push(lead.email);
                }

              case 100:
                _iteratorNormalCompletion5 = true;
                _context19.next = 94;
                break;

              case 103:
                _context19.next = 109;
                break;

              case 105:
                _context19.prev = 105;
                _context19.t0 = _context19["catch"](92);
                _didIteratorError5 = true;
                _iteratorError5 = _context19.t0;

              case 109:
                _context19.prev = 109;
                _context19.prev = 110;

                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }

              case 112:
                _context19.prev = 112;

                if (!_didIteratorError5) {
                  _context19.next = 115;
                  break;
                }

                throw _iteratorError5;

              case 115:
                return _context19.finish(112);

              case 116:
                return _context19.finish(109);

              case 117:
                _context19.next = 166;
                break;

              case 119:
                if (!(position === "Responsable DRM" && customer._drmRespIds && customer._drmRespIds.length)) {
                  _context19.next = 150;
                  break;
                }

                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context19.prev = 123;
                _iterator6 = customer._drmRespIds[Symbol.iterator]();

              case 125:
                if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                  _context19.next = 134;
                  break;
                }

                drmRespId = _step6.value;
                _context19.next = 129;
                return UsersService.getById(drmRespId);

              case 129:
                drmResp = _context19.sent;

                if (drmResp && drmResp.email) {
                  emails.push(drmResp.email);
                }

              case 131:
                _iteratorNormalCompletion6 = true;
                _context19.next = 125;
                break;

              case 134:
                _context19.next = 140;
                break;

              case 136:
                _context19.prev = 136;
                _context19.t1 = _context19["catch"](123);
                _didIteratorError6 = true;
                _iteratorError6 = _context19.t1;

              case 140:
                _context19.prev = 140;
                _context19.prev = 141;

                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }

              case 143:
                _context19.prev = 143;

                if (!_didIteratorError6) {
                  _context19.next = 146;
                  break;
                }

                throw _iteratorError6;

              case 146:
                return _context19.finish(143);

              case 147:
                return _context19.finish(140);

              case 148:
                _context19.next = 166;
                break;

              case 150:
                if (!(position === "Responsable du suivi")) {
                  _context19.next = 157;
                  break;
                }

                _context19.next = 153;
                return UsersService.getById(damage.managerId);

              case 153:
                _manager6 = _context19.sent;

                if (_manager6 && _manager6.email) {
                  emails.push(_manager6.email);
                }
                _context19.next = 166;
                break;

              case 157:
                if (!(position === "N+2")) {
                  _context19.next = 166;
                  break;
                }

                _context19.next = 160;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 160:
                _manager7 = _context19.sent;

                if (!(_manager7 && _manager7.defaultManagerId)) {
                  _context19.next = 166;
                  break;
                }

                _context19.next = 164;
                return UsersService.getById(_manager7.defaultManagerId);

              case 164:
                managerN2 = _context19.sent;

                if (managerN2 && managerN2.email) {
                  emails.push(managerN2.email);
                }

              case 166:
                _iteratorNormalCompletion4 = true;
                _context19.next = 39;
                break;

              case 169:
                _context19.next = 175;
                break;

              case 171:
                _context19.prev = 171;
                _context19.t2 = _context19["catch"](37);
                _didIteratorError4 = true;
                _iteratorError4 = _context19.t2;

              case 175:
                _context19.prev = 175;
                _context19.prev = 176;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 178:
                _context19.prev = 178;

                if (!_didIteratorError4) {
                  _context19.next = 181;
                  break;
                }

                throw _iteratorError4;

              case 181:
                return _context19.finish(178);

              case 182:
                return _context19.finish(175);

              case 183:
                if (!customer.reminderByUserCancel) {
                  _context19.next = 212;
                  break;
                }

                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context19.prev = 187;
                _iterator7 = customer.reminderByUserCancel[Symbol.iterator]();

              case 189:
                if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
                  _context19.next = 198;
                  break;
                }

                userId = _step7.value;
                _context19.next = 193;
                return UsersService.getById(userId);

              case 193:
                user = _context19.sent;

                if (user && user.email) {
                  emails.push(user.email);
                }

              case 195:
                _iteratorNormalCompletion7 = true;
                _context19.next = 189;
                break;

              case 198:
                _context19.next = 204;
                break;

              case 200:
                _context19.prev = 200;
                _context19.t3 = _context19["catch"](187);
                _didIteratorError7 = true;
                _iteratorError7 = _context19.t3;

              case 204:
                _context19.prev = 204;
                _context19.prev = 205;

                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }

              case 207:
                _context19.prev = 207;

                if (!_didIteratorError7) {
                  _context19.next = 210;
                  break;
                }

                throw _iteratorError7;

              case 210:
                return _context19.finish(207);

              case 211:
                return _context19.finish(204);

              case 212:
                if (customer.reminderByEmailPhoneToUseCancel) {
                  if (oldEmailToUse) {
                    emails.push(oldEmailToUse);
                  }
                  if (oldPhoneToUse) {
                    damage.depa.phoneToUse = oldPhoneToUse;
                  }
                }

                // remove duplicates
                emails = emails.filter(function (item, index) {
                  return emails.indexOf(item) === index;
                });

                damage.depa.emailToUse = emails.join(",");
                _context19.next = 588;
                break;

              case 217:
                _context19.next = 219;
                return CustomersService.getById($rootScope.$selectedCustomerId);

              case 219:
                _customer = _context19.sent;
                nextReminder = "1";

                if (damage.depa.emailReminderDate2) {
                  nextReminder = "3";
                } else if (damage.depa.emailReminderDate1) {
                  nextReminder = "2";
                }

                _emails = [];


                if (_customer["reminderByEmailPhoneToUseReport"]) {
                  if (damage.depa.emailToUse) {
                    _emails.push(damage.depa.emailToUse);
                  }
                }
                damage.depa.phoneToUse = _customer["reminderByEmailPhoneToUseReport"] ? damage.depa.phoneToUse : null;

                if (!_customer["reminderByPositionReport"]) {
                  _context19.next = 375;
                  break;
                }

                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context19.prev = 229;
                _iterator8 = _customer["reminderByPositionReport"][Symbol.iterator]();

              case 231:
                if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
                  _context19.next = 361;
                  break;
                }

                _position = _step8.value;

                if (!(_position === "Conducteur")) {
                  _context19.next = 238;
                  break;
                }

                if (damage.driver.cellularPhone && (!_customer["reminderByEmailPhoneToUse" + nextReminder] || !damage.depa.phoneToUse)) {
                  damage.depa.phoneToUse = damage.driver.cellularPhone;
                }
                if (damage.driver.email) {
                  _emails.push(damage.driver.email);
                }
                _context19.next = 358;
                break;

              case 238:
                if (!(_position === "Manageur")) {
                  _context19.next = 245;
                  break;
                }

                _context19.next = 241;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 241:
                _manager8 = _context19.sent;

                if (_manager8 && _manager8.email) {
                  _emails.push(_manager8.email);
                }
                _context19.next = 358;
                break;

              case 245:
                if (!(_position === "RH")) {
                  _context19.next = 252;
                  break;
                }

                _context19.next = 248;
                return UsersService.getById(damage.driver.rhManagerId);

              case 248:
                _manager9 = _context19.sent;

                if (_manager9 && _manager9.email) {
                  _emails.push(_manager9.email);
                }
                _context19.next = 358;
                break;

              case 252:
                if (!(_position === "QSE")) {
                  _context19.next = 259;
                  break;
                }

                _context19.next = 255;
                return UsersService.getById(damage.driver.qseManagerId);

              case 255:
                _manager10 = _context19.sent;

                if (_manager10 && _manager10.email) {
                  _emails.push(_manager10.email);
                }
                _context19.next = 358;
                break;

              case 259:
                if (!(_position === "Gestionnaire Parc")) {
                  _context19.next = 266;
                  break;
                }

                _context19.next = 262;
                return UsersService.getById(damage.driver.fleetManagerId);

              case 262:
                _manager11 = _context19.sent;

                if (_manager11 && _manager11.email) {
                  _emails.push(_manager11.email);
                }
                _context19.next = 358;
                break;

              case 266:
                if (!(_position === "Autre responsable 1")) {
                  _context19.next = 273;
                  break;
                }

                _context19.next = 269;
                return UsersService.getById(damage.driver.other1ManagerId);

              case 269:
                _manager12 = _context19.sent;

                if (_manager12 && _manager12.email) {
                  _emails.push(_manager12.email);
                }
                _context19.next = 358;
                break;

              case 273:
                if (!(_position === "Autre responsable 2")) {
                  _context19.next = 280;
                  break;
                }

                _context19.next = 276;
                return UsersService.getById(damage.driver.other2ManagerId);

              case 276:
                _manager13 = _context19.sent;

                if (_manager13 && _manager13.email) {
                  _emails.push(_manager13.email);
                }
                _context19.next = 358;
                break;

              case 280:
                if (!(_position === "LEAD" && _customer._leadIds && _customer._leadIds.length)) {
                  _context19.next = 311;
                  break;
                }

                _iteratorNormalCompletion9 = true;
                _didIteratorError9 = false;
                _iteratorError9 = undefined;
                _context19.prev = 284;
                _iterator9 = _customer._leadIds[Symbol.iterator]();

              case 286:
                if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
                  _context19.next = 295;
                  break;
                }

                _leadId = _step9.value;
                _context19.next = 290;
                return UsersService.getById(_leadId);

              case 290:
                _lead = _context19.sent;

                if (_lead && _lead.email) {
                  _emails.push(_lead.email);
                }

              case 292:
                _iteratorNormalCompletion9 = true;
                _context19.next = 286;
                break;

              case 295:
                _context19.next = 301;
                break;

              case 297:
                _context19.prev = 297;
                _context19.t4 = _context19["catch"](284);
                _didIteratorError9 = true;
                _iteratorError9 = _context19.t4;

              case 301:
                _context19.prev = 301;
                _context19.prev = 302;

                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                  _iterator9.return();
                }

              case 304:
                _context19.prev = 304;

                if (!_didIteratorError9) {
                  _context19.next = 307;
                  break;
                }

                throw _iteratorError9;

              case 307:
                return _context19.finish(304);

              case 308:
                return _context19.finish(301);

              case 309:
                _context19.next = 358;
                break;

              case 311:
                if (!(_position === "Responsable DRM" && _customer._drmRespIds && _customer._drmRespIds.length)) {
                  _context19.next = 342;
                  break;
                }

                _iteratorNormalCompletion10 = true;
                _didIteratorError10 = false;
                _iteratorError10 = undefined;
                _context19.prev = 315;
                _iterator10 = _customer._drmRespIds[Symbol.iterator]();

              case 317:
                if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                  _context19.next = 326;
                  break;
                }

                _drmRespId = _step10.value;
                _context19.next = 321;
                return UsersService.getById(_drmRespId);

              case 321:
                _drmResp = _context19.sent;

                if (_drmResp && _drmResp.email) {
                  _emails.push(_drmResp.email);
                }

              case 323:
                _iteratorNormalCompletion10 = true;
                _context19.next = 317;
                break;

              case 326:
                _context19.next = 332;
                break;

              case 328:
                _context19.prev = 328;
                _context19.t5 = _context19["catch"](315);
                _didIteratorError10 = true;
                _iteratorError10 = _context19.t5;

              case 332:
                _context19.prev = 332;
                _context19.prev = 333;

                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }

              case 335:
                _context19.prev = 335;

                if (!_didIteratorError10) {
                  _context19.next = 338;
                  break;
                }

                throw _iteratorError10;

              case 338:
                return _context19.finish(335);

              case 339:
                return _context19.finish(332);

              case 340:
                _context19.next = 358;
                break;

              case 342:
                if (!(_position === "Responsable du suivi")) {
                  _context19.next = 349;
                  break;
                }

                _context19.next = 345;
                return UsersService.getById(damage.managerId);

              case 345:
                _manager14 = _context19.sent;

                if (_manager14 && _manager14.email) {
                  _emails.push(_manager14.email);
                }
                _context19.next = 358;
                break;

              case 349:
                if (!(_position === "N+2")) {
                  _context19.next = 358;
                  break;
                }

                _context19.next = 352;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 352:
                _manager15 = _context19.sent;

                if (!(_manager15 && _manager15.defaultManagerId)) {
                  _context19.next = 358;
                  break;
                }

                _context19.next = 356;
                return UsersService.getById(_manager15.defaultManagerId);

              case 356:
                _managerN = _context19.sent;

                if (_managerN && _managerN.email) {
                  _emails.push(_managerN.email);
                }

              case 358:
                _iteratorNormalCompletion8 = true;
                _context19.next = 231;
                break;

              case 361:
                _context19.next = 367;
                break;

              case 363:
                _context19.prev = 363;
                _context19.t6 = _context19["catch"](229);
                _didIteratorError8 = true;
                _iteratorError8 = _context19.t6;

              case 367:
                _context19.prev = 367;
                _context19.prev = 368;

                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }

              case 370:
                _context19.prev = 370;

                if (!_didIteratorError8) {
                  _context19.next = 373;
                  break;
                }

                throw _iteratorError8;

              case 373:
                return _context19.finish(370);

              case 374:
                return _context19.finish(367);

              case 375:
                if (!_customer["reminderByUserReport"]) {
                  _context19.next = 404;
                  break;
                }

                _iteratorNormalCompletion11 = true;
                _didIteratorError11 = false;
                _iteratorError11 = undefined;
                _context19.prev = 379;
                _iterator11 = _customer["reminderByUserReport"][Symbol.iterator]();

              case 381:
                if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
                  _context19.next = 390;
                  break;
                }

                _userId = _step11.value;
                _context19.next = 385;
                return UsersService.getById(_userId);

              case 385:
                _user = _context19.sent;

                if (_user && _user.email) {
                  _emails.push(_user.email);
                }

              case 387:
                _iteratorNormalCompletion11 = true;
                _context19.next = 381;
                break;

              case 390:
                _context19.next = 396;
                break;

              case 392:
                _context19.prev = 392;
                _context19.t7 = _context19["catch"](379);
                _didIteratorError11 = true;
                _iteratorError11 = _context19.t7;

              case 396:
                _context19.prev = 396;
                _context19.prev = 397;

                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }

              case 399:
                _context19.prev = 399;

                if (!_didIteratorError11) {
                  _context19.next = 402;
                  break;
                }

                throw _iteratorError11;

              case 402:
                return _context19.finish(399);

              case 403:
                return _context19.finish(396);

              case 404:
                if (_emails.length) {
                  _context19.next = 586;
                  break;
                }

                if (_customer["reminderByEmailPhoneToUse" + nextReminder] && damage.depa.emailToUse) {
                  _emails.push(damage.depa.emailToUse);
                }
                damage.depa.phoneToUse = _customer["reminderByEmailPhoneToUse" + nextReminder] ? damage.depa.phoneToUse : null;

                if (!_customer["reminderByPositionDepa" + nextReminder]) {
                  _context19.next = 557;
                  break;
                }

                _iteratorNormalCompletion12 = true;
                _didIteratorError12 = false;
                _iteratorError12 = undefined;
                _context19.prev = 411;
                _iterator12 = _customer["reminderByPositionDepa" + nextReminder][Symbol.iterator]();

              case 413:
                if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
                  _context19.next = 543;
                  break;
                }

                _position2 = _step12.value;

                if (!(_position2 === "Conducteur")) {
                  _context19.next = 420;
                  break;
                }

                if (damage.driver.cellularPhone && (!_customer["reminderByEmailPhoneToUse" + nextReminder] || !damage.depa.phoneToUse)) {
                  damage.depa.phoneToUse = damage.driver.cellularPhone;
                }
                if (damage.driver.email) {
                  _emails.push(damage.driver.email);
                }
                _context19.next = 540;
                break;

              case 420:
                if (!(_position2 === "Manageur")) {
                  _context19.next = 427;
                  break;
                }

                _context19.next = 423;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 423:
                _manager16 = _context19.sent;

                if (_manager16 && _manager16.email) {
                  _emails.push(_manager16.email);
                }
                _context19.next = 540;
                break;

              case 427:
                if (!(_position2 === "RH")) {
                  _context19.next = 434;
                  break;
                }

                _context19.next = 430;
                return UsersService.getById(damage.driver.rhManagerId);

              case 430:
                _manager17 = _context19.sent;

                if (_manager17 && _manager17.email) {
                  _emails.push(_manager17.email);
                }
                _context19.next = 540;
                break;

              case 434:
                if (!(_position2 === "QSE")) {
                  _context19.next = 441;
                  break;
                }

                _context19.next = 437;
                return UsersService.getById(damage.driver.qseManagerId);

              case 437:
                _manager18 = _context19.sent;

                if (_manager18 && _manager18.email) {
                  _emails.push(_manager18.email);
                }
                _context19.next = 540;
                break;

              case 441:
                if (!(_position2 === "Gestionnaire Parc")) {
                  _context19.next = 448;
                  break;
                }

                _context19.next = 444;
                return UsersService.getById(damage.driver.fleetManagerId);

              case 444:
                _manager19 = _context19.sent;

                if (_manager19 && _manager19.email) {
                  _emails.push(_manager19.email);
                }
                _context19.next = 540;
                break;

              case 448:
                if (!(_position2 === "Autre responsable 1")) {
                  _context19.next = 455;
                  break;
                }

                _context19.next = 451;
                return UsersService.getById(damage.driver.other1ManagerId);

              case 451:
                _manager20 = _context19.sent;

                if (_manager20 && _manager20.email) {
                  _emails.push(_manager20.email);
                }
                _context19.next = 540;
                break;

              case 455:
                if (!(_position2 === "Autre responsable 2")) {
                  _context19.next = 462;
                  break;
                }

                _context19.next = 458;
                return UsersService.getById(damage.driver.other2ManagerId);

              case 458:
                _manager21 = _context19.sent;

                if (_manager21 && _manager21.email) {
                  _emails.push(_manager21.email);
                }
                _context19.next = 540;
                break;

              case 462:
                if (!(_position2 === "LEAD" && _customer._leadIds && _customer._leadIds.length)) {
                  _context19.next = 493;
                  break;
                }

                _iteratorNormalCompletion13 = true;
                _didIteratorError13 = false;
                _iteratorError13 = undefined;
                _context19.prev = 466;
                _iterator13 = _customer._leadIds[Symbol.iterator]();

              case 468:
                if (_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done) {
                  _context19.next = 477;
                  break;
                }

                _leadId2 = _step13.value;
                _context19.next = 472;
                return UsersService.getById(_leadId2);

              case 472:
                _lead2 = _context19.sent;

                if (_lead2 && _lead2.email) {
                  _emails.push(_lead2.email);
                }

              case 474:
                _iteratorNormalCompletion13 = true;
                _context19.next = 468;
                break;

              case 477:
                _context19.next = 483;
                break;

              case 479:
                _context19.prev = 479;
                _context19.t8 = _context19["catch"](466);
                _didIteratorError13 = true;
                _iteratorError13 = _context19.t8;

              case 483:
                _context19.prev = 483;
                _context19.prev = 484;

                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }

              case 486:
                _context19.prev = 486;

                if (!_didIteratorError13) {
                  _context19.next = 489;
                  break;
                }

                throw _iteratorError13;

              case 489:
                return _context19.finish(486);

              case 490:
                return _context19.finish(483);

              case 491:
                _context19.next = 540;
                break;

              case 493:
                if (!(_position2 === "Responsable DRM" && _customer._drmRespIds && _customer._drmRespIds.length)) {
                  _context19.next = 524;
                  break;
                }

                _iteratorNormalCompletion14 = true;
                _didIteratorError14 = false;
                _iteratorError14 = undefined;
                _context19.prev = 497;
                _iterator14 = _customer._drmRespIds[Symbol.iterator]();

              case 499:
                if (_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done) {
                  _context19.next = 508;
                  break;
                }

                _drmRespId2 = _step14.value;
                _context19.next = 503;
                return UsersService.getById(_drmRespId2);

              case 503:
                _drmResp2 = _context19.sent;

                if (_drmResp2 && _drmResp2.email) {
                  _emails.push(_drmResp2.email);
                }

              case 505:
                _iteratorNormalCompletion14 = true;
                _context19.next = 499;
                break;

              case 508:
                _context19.next = 514;
                break;

              case 510:
                _context19.prev = 510;
                _context19.t9 = _context19["catch"](497);
                _didIteratorError14 = true;
                _iteratorError14 = _context19.t9;

              case 514:
                _context19.prev = 514;
                _context19.prev = 515;

                if (!_iteratorNormalCompletion14 && _iterator14.return) {
                  _iterator14.return();
                }

              case 517:
                _context19.prev = 517;

                if (!_didIteratorError14) {
                  _context19.next = 520;
                  break;
                }

                throw _iteratorError14;

              case 520:
                return _context19.finish(517);

              case 521:
                return _context19.finish(514);

              case 522:
                _context19.next = 540;
                break;

              case 524:
                if (!(_position2 === "Responsable du suivi")) {
                  _context19.next = 531;
                  break;
                }

                _context19.next = 527;
                return UsersService.getById(damage.managerId);

              case 527:
                _manager22 = _context19.sent;

                if (_manager22 && _manager22.email) {
                  _emails.push(_manager22.email);
                }
                _context19.next = 540;
                break;

              case 531:
                if (!(_position2 === "N+2")) {
                  _context19.next = 540;
                  break;
                }

                _context19.next = 534;
                return UsersService.getById(damage.driver.defaultManagerId);

              case 534:
                _manager23 = _context19.sent;

                if (!(_manager23 && _manager23.defaultManagerId)) {
                  _context19.next = 540;
                  break;
                }

                _context19.next = 538;
                return UsersService.getById(_manager23.defaultManagerId);

              case 538:
                _managerN2 = _context19.sent;

                if (_managerN2 && _managerN2.email) {
                  _emails.push(_managerN2.email);
                }

              case 540:
                _iteratorNormalCompletion12 = true;
                _context19.next = 413;
                break;

              case 543:
                _context19.next = 549;
                break;

              case 545:
                _context19.prev = 545;
                _context19.t10 = _context19["catch"](411);
                _didIteratorError12 = true;
                _iteratorError12 = _context19.t10;

              case 549:
                _context19.prev = 549;
                _context19.prev = 550;

                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }

              case 552:
                _context19.prev = 552;

                if (!_didIteratorError12) {
                  _context19.next = 555;
                  break;
                }

                throw _iteratorError12;

              case 555:
                return _context19.finish(552);

              case 556:
                return _context19.finish(549);

              case 557:
                if (!_customer["reminderByUserDepa" + nextReminder]) {
                  _context19.next = 586;
                  break;
                }

                _iteratorNormalCompletion15 = true;
                _didIteratorError15 = false;
                _iteratorError15 = undefined;
                _context19.prev = 561;
                _iterator15 = _customer["reminderByUserDepa" + nextReminder][Symbol.iterator]();

              case 563:
                if (_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done) {
                  _context19.next = 572;
                  break;
                }

                _userId2 = _step15.value;
                _context19.next = 567;
                return UsersService.getById(_userId2);

              case 567:
                _user2 = _context19.sent;

                if (_user2 && _user2.email) {
                  _emails.push(_user2.email);
                }

              case 569:
                _iteratorNormalCompletion15 = true;
                _context19.next = 563;
                break;

              case 572:
                _context19.next = 578;
                break;

              case 574:
                _context19.prev = 574;
                _context19.t11 = _context19["catch"](561);
                _didIteratorError15 = true;
                _iteratorError15 = _context19.t11;

              case 578:
                _context19.prev = 578;
                _context19.prev = 579;

                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }

              case 581:
                _context19.prev = 581;

                if (!_didIteratorError15) {
                  _context19.next = 584;
                  break;
                }

                throw _iteratorError15;

              case 584:
                return _context19.finish(581);

              case 585:
                return _context19.finish(578);

              case 586:

                // remove duplicates
                _emails = _emails.filter(function (item, index) {
                  return _emails.indexOf(item) === index;
                });

                // replace only if there is at least one email
                if (_emails.length > 0) {
                  damage.depa.emailToUse = _emails.join(",");
                }

              case 588:
                if (!openModal) {
                  _context19.next = 593;
                  break;
                }

                _context19.next = 591;
                return schedule(damage);

              case 591:
                _context19.next = 661;
                break;

              case 593:
                if (!(damage.depa && (damage.depa.emailToUse || damage.depa.phoneToUse) && damage.depa.status !== "Programmé" && damage.depa.status !== "Effectué" && (!damage.depa.missingCount || damage.depa.missingCount < 3))) {
                  _context19.next = 659;
                  break;
                }

                container = document.createElement("div");
                buttonText = "Modifier le destinataire ou prendre le RDV";
                text = "Voulez-vous renvoyer le lien pour programmer le RDV";

                if (damage.depa.status === "Annulé") {
                  buttonText = "Modifier le destinataire";
                  text = "Voulez-vous envoyer le mail/sms d'annulation du DEPA";
                }

                button = document.createElement("button");

                button.className = "swal-button";
                button.innerHTML = buttonText;
                button.onclick = function () {
                  var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                    return regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            swal.close();
                            _context18.next = 3;
                            return schedule(damage);

                          case 3:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18, this);
                  }));

                  function onClick() {
                    return _ref19.apply(this, arguments);
                  }

                  return onClick;
                }();
                container.append(button);

                _context19.next = 605;
                return swal({
                  text: text + " " + (damage.driverName ? "de " + damage.driverName : "") + " ? \n" + (damage.depa.emailToUse ? " \n[ email : " + damage.depa.emailToUse + " ] " : "[ email : ??? ]") + " " + (damage.depa.phoneToUse ? " \n[ sms : " + damage.depa.phoneToUse + " ]" : "[ sms : ??? ]"),
                  content: {
                    element: container
                  },
                  icon: "warning",
                  dangerMode: true,
                  buttons: ["Non", "Oui"]
                });

              case 605:
                confirmSend = _context19.sent;
                allowSave = true;
                phoneMobileRegex = /^\+[1-9]\d{6,14}$/;


                if (damage.depa.phoneToUse && !phoneMobileRegex.test(damage.depa.phoneToUse)) {
                  Notiflix.Notify.failure("Le format du portable n'est pas valide");
                  allowSave = false;
                }

                emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!damage.depa.emailToUse) {
                  _context19.next = 630;
                  break;
                }

                _iteratorNormalCompletion16 = true;
                _didIteratorError16 = false;
                _iteratorError16 = undefined;
                _context19.prev = 614;

                for (_iterator16 = damage.depa.emailToUse.split(",")[Symbol.iterator](); !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                  email = _step16.value;

                  if (email && !emailRegex.test(email)) {
                    Notiflix.Notify.failure("Le format de l'email n'est pas valide");
                    allowSave = false;
                  }
                }
                _context19.next = 622;
                break;

              case 618:
                _context19.prev = 618;
                _context19.t12 = _context19["catch"](614);
                _didIteratorError16 = true;
                _iteratorError16 = _context19.t12;

              case 622:
                _context19.prev = 622;
                _context19.prev = 623;

                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }

              case 625:
                _context19.prev = 625;

                if (!_didIteratorError16) {
                  _context19.next = 628;
                  break;
                }

                throw _iteratorError16;

              case 628:
                return _context19.finish(625);

              case 629:
                return _context19.finish(622);

              case 630:
                if (!(confirmSend && allowSave)) {
                  _context19.next = 657;
                  break;
                }

                if (!(!damage.depa.emailToUse && !damage.depa.phoneToUse)) {
                  _context19.next = 634;
                  break;
                }

                Notiflix.Notify.failure("Vous devez indiquer un numéro de téléphone ou un email.");
                return _context19.abrupt("return");

              case 634:
                values = { emailName: "toScheduled" };

                values.emailToUse = damage.depa.emailToUse;
                values.phoneToUse = damage.depa.phoneToUse;
                if (damage.depa.status === "Annulé") {
                  values.emailName = "meetingCancel";
                } else {
                  if (damage.depa.status.endsWith("A reprogrammer")) {
                    values.emailName = "driverNotAvailable";
                  }
                }

                Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                _context19.prev = 639;
                _context19.next = 642;
                return DepasService.updateAttributesById(damage.depaId.replace("$", ""), values);

              case 642:
                response = _context19.sent;

                if (response._id) {
                  _context19.next = 647;
                  break;
                }

                Notiflix.Notify.failure("", "Une erreur est survenue lors de la sauvegarde.");
                Notiflix.Loading.remove();
                return _context19.abrupt("return");

              case 647:
                Notiflix.Notify.success("La demande a bien été prise en compte.");
                Notiflix.Loading.remove();
                _context19.next = 653;
                break;

              case 651:
                _context19.prev = 651;
                _context19.t13 = _context19["catch"](639);

              case 653:
                if (!(noRefresh !== true)) {
                  _context19.next = 656;
                  break;
                }

                _context19.next = 656;
                return vm.refresh();

              case 656:
                return _context19.abrupt("return");

              case 657:
                _context19.next = 661;
                break;

              case 659:
                _context19.next = 661;
                return schedule(damage);

              case 661:
                _context19.next = 665;
                break;

              case 663:
                _context19.next = 665;
                return swal("", "Ce sinistre ne nécessite pas de DEPA.", "info");

              case 665:
                _context19.next = 670;
                break;

              case 667:
                _context19.prev = 667;
                _context19.t14 = _context19["catch"](0);

                Notiflix.Notify.failure("Une erreur est survenue");

              case 670:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this, [[0, 667], [37, 171, 175, 183], [92, 105, 109, 117], [110,, 112, 116], [123, 136, 140, 148], [141,, 143, 147], [176,, 178, 182], [187, 200, 204, 212], [205,, 207, 211], [229, 363, 367, 375], [284, 297, 301, 309], [302,, 304, 308], [315, 328, 332, 340], [333,, 335, 339], [368,, 370, 374], [379, 392, 396, 404], [397,, 399, 403], [411, 545, 549, 557], [466, 479, 483, 491], [484,, 486, 490], [497, 510, 514, 522], [515,, 517, 521], [550,, 552, 556], [561, 574, 578, 586], [579,, 581, 585], [614, 618, 622, 630], [623,, 625, 629], [639, 651]]);
      }));

      return function (_x15) {
        return _ref17.apply(this, arguments);
      };
    }();

    vm.delete = function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(row) {
        var deleteDamage;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return swal({
                  title: "Voulez-vous supprimer le sinistre " + row.name + " et le DEPA associ\xE9 s'il existe ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteDamage = _context21.sent;

                if (!deleteDamage) {
                  _context21.next = 7;
                  break;
                }

                console.log("need to delete this damage", row);
                _context21.next = 7;
                return DamagesService.deleteById(row._id).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
                  return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          Notiflix.Notify.success("La suppression a réussi");
                          _context20.next = 3;
                          return vm.refresh();

                        case 3:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20, this);
                })));

              case 7:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this);
      }));

      return function (_x20) {
        return _ref20.apply(this, arguments);
      };
    }();

    vm.refresh();
  }
})();